import { x as de, i as E, t as Q, T as lt, m as Qi, n as Zi, o as ki, v as P, u as ve, l as ts, b as H, f as ut, g as N, h as St, d as R, s as et, j as ft, a as It, e as we, r as es, c as Me, aG as q, a3 as gt, ac as is, ad as ss, k as L, ae as ke, af as Se, Q as T, F as C, ag as De, a7 as Ut, ah as Si, Y as Yt, $ as Xt, C as be, ai as Ht, aj as ns, q as as, w as os, S as Z, aM as rs, aw as Vt, av as ue, an as hs, ao as ls, ap as Di, E as W, a0 as F, a2 as B, P as Wt, Z as Dt, a1 as _e, aF as cs, ay as ct, aA as dt, aB as Pi, aD as Ai, aC as ds, ak as ot, a5 as us, a6 as Pe, a8 as Ae, M as Ci, z as at, O as Y, R as gs, U as fs, V as Ce, W as ps, X as nt, aH as xs, aq as ms, ar as bs, as as _s, aE as ys, a9 as vs, aa as ws, G as Ms, I as Oi, _ as ks, aI as Oe, aJ as Ss, aK as Qt, ax as Ds, a4 as Ps, ab as Zt, J as Te, L as Ti, N as As, aL as Ie, at as Cs, au as Os, K as Ts, A as Is, B as Ls, D as Es, p as ge, az as Rs, al as Le, H as Nt } from "./index.es272.js";
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class zs {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, e, i, s) {
    const a = e.listeners[s], o = e.duration;
    a.forEach((r) => r({
      chart: t,
      initial: e.initial,
      numSteps: o,
      currentStep: Math.min(i - e.start, o)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = es.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let e = 0;
    this._charts.forEach((i, s) => {
      if (!i.running || !i.items.length)
        return;
      const a = i.items;
      let o = a.length - 1, r = !1, h;
      for (; o >= 0; --o)
        h = a[o], h._active ? (h._total > i.duration && (i.duration = h._total), h.tick(t), r = !0) : (a[o] = a[a.length - 1], a.pop());
      r && (s.draw(), this._notify(s, i, t, "progress")), a.length || (i.running = !1, this._notify(s, i, t, "complete"), i.initial = !1), e += a.length;
    }), this._lastDate = t, e === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const e = this._charts;
    let i = e.get(t);
    return i || (i = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, e.set(t, i)), i;
  }
  listen(t, e, i) {
    this._getAnims(t).listeners[e].push(i);
  }
  add(t, e) {
    !e || !e.length || this._getAnims(t).items.push(...e);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const e = this._charts.get(t);
    e && (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((i, s) => Math.max(i, s._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const e = this._charts.get(t);
    return !(!e || !e.running || !e.items.length);
  }
  stop(t) {
    const e = this._charts.get(t);
    if (!e || !e.items.length)
      return;
    const i = e.items;
    let s = i.length - 1;
    for (; s >= 0; --s)
      i[s].cancel();
    e.items = [], this._notify(t, e, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var G = /* @__PURE__ */ new zs();
const Ee = "transparent", Bs = {
  boolean(n, t, e) {
    return e > 0.5 ? t : n;
  },
  color(n, t, e) {
    const i = Me(n || Ee), s = i.valid && Me(t || Ee);
    return s && s.valid ? s.mix(i, e).hexString() : t;
  },
  number(n, t, e) {
    return n + (t - n) * e;
  }
};
class Fs {
  constructor(t, e, i, s) {
    const a = e[i];
    s = It([
      t.to,
      s,
      a,
      t.from
    ]);
    const o = It([
      t.from,
      a,
      s
    ]);
    this._active = !0, this._fn = t.fn || Bs[t.type || typeof o], this._easing = we[t.easing] || we.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = i, this._from = o, this._to = s, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, e, i) {
    if (this._active) {
      this._notify(!1);
      const s = this._target[this._prop], a = i - this._start, o = this._duration - a;
      this._start = i, this._duration = Math.floor(Math.max(o, t.duration)), this._total += a, this._loop = !!t.loop, this._to = It([
        t.to,
        e,
        s,
        t.from
      ]), this._from = It([
        t.from,
        s,
        e
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const e = t - this._start, i = this._duration, s = this._prop, a = this._from, o = this._loop, r = this._to;
    let h;
    if (this._active = a !== r && (o || e < i), !this._active) {
      this._target[s] = r, this._notify(!0);
      return;
    }
    if (e < 0) {
      this._target[s] = a;
      return;
    }
    h = e / i % 2, h = o && h > 1 ? 2 - h : h, h = this._easing(Math.min(1, Math.max(0, h))), this._target[s] = this._fn(a, r, h);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((e, i) => {
      t.push({
        res: e,
        rej: i
      });
    });
  }
  _notify(t) {
    const e = t ? "res" : "rej", i = this._promises || [];
    for (let s = 0; s < i.length; s++)
      i[s][e]();
  }
}
class Ii {
  constructor(t, e) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(e);
  }
  configure(t) {
    if (!E(t))
      return;
    const e = Object.keys(R.animation), i = this._properties;
    Object.getOwnPropertyNames(t).forEach((s) => {
      const a = t[s];
      if (!E(a))
        return;
      const o = {};
      for (const r of e)
        o[r] = a[r];
      (H(a.properties) && a.properties || [
        s
      ]).forEach((r) => {
        (r === s || !i.has(r)) && i.set(r, o);
      });
    });
  }
  _animateOptions(t, e) {
    const i = e.options, s = Hs(t, i);
    if (!s)
      return [];
    const a = this._createAnimations(s, i);
    return i.$shared && $s(t.options.$animations, i).then(() => {
      t.options = i;
    }, () => {
    }), a;
  }
  _createAnimations(t, e) {
    const i = this._properties, s = [], a = t.$animations || (t.$animations = {}), o = Object.keys(e), r = Date.now();
    let h;
    for (h = o.length - 1; h >= 0; --h) {
      const l = o[h];
      if (l.charAt(0) === "$")
        continue;
      if (l === "options") {
        s.push(...this._animateOptions(t, e));
        continue;
      }
      const c = e[l];
      let d = a[l];
      const u = i.get(l);
      if (d)
        if (u && d.active()) {
          d.update(u, c, r);
          continue;
        } else
          d.cancel();
      if (!u || !u.duration) {
        t[l] = c;
        continue;
      }
      a[l] = d = new Fs(u, t, l, c), s.push(d);
    }
    return s;
  }
  update(t, e) {
    if (this._properties.size === 0) {
      Object.assign(t, e);
      return;
    }
    const i = this._createAnimations(t, e);
    if (i.length)
      return G.add(this._chart, i), !0;
  }
}
function $s(n, t) {
  const e = [], i = Object.keys(t);
  for (let s = 0; s < i.length; s++) {
    const a = n[i[s]];
    a && a.active() && e.push(a.wait());
  }
  return Promise.all(e);
}
function Hs(n, t) {
  if (!t)
    return;
  let e = n.options;
  if (!e) {
    n.options = t;
    return;
  }
  return e.$shared && (n.options = e = Object.assign({}, e, {
    $shared: !1,
    $animations: {}
  })), e;
}
function Re(n, t) {
  const e = n && n.options || {}, i = e.reverse, s = e.min === void 0 ? t : 0, a = e.max === void 0 ? t : 0;
  return {
    start: i ? a : s,
    end: i ? s : a
  };
}
function Vs(n, t, e) {
  if (e === !1)
    return !1;
  const i = Re(n, e), s = Re(t, e);
  return {
    top: s.end,
    right: i.end,
    bottom: s.start,
    left: i.start
  };
}
function Ws(n) {
  let t, e, i, s;
  return E(n) ? (t = n.top, e = n.right, i = n.bottom, s = n.left) : t = e = i = s = n, {
    top: t,
    right: e,
    bottom: i,
    left: s,
    disabled: n === !1
  };
}
function Li(n, t) {
  const e = [], i = n._getSortedDatasetMetas(t);
  let s, a;
  for (s = 0, a = i.length; s < a; ++s)
    e.push(i[s].index);
  return e;
}
function ze(n, t, e, i = {}) {
  const s = n.keys, a = i.mode === "single";
  let o, r, h, l;
  if (t === null)
    return;
  let c = !1;
  for (o = 0, r = s.length; o < r; ++o) {
    if (h = +s[o], h === e) {
      if (c = !0, i.all)
        continue;
      break;
    }
    l = n.values[h], N(l) && (a || t === 0 || et(t) === et(l)) && (t += l);
  }
  return !c && !i.all ? 0 : t;
}
function Ns(n, t) {
  const { iScale: e, vScale: i } = t, s = e.axis === "x" ? "x" : "y", a = i.axis === "x" ? "x" : "y", o = Object.keys(n), r = new Array(o.length);
  let h, l, c;
  for (h = 0, l = o.length; h < l; ++h)
    c = o[h], r[h] = {
      [s]: c,
      [a]: n[c]
    };
  return r;
}
function te(n, t) {
  const e = n && n.options.stacked;
  return e || e === void 0 && t.stack !== void 0;
}
function js(n, t, e) {
  return `${n.id}.${t.id}.${e.stack || e.type}`;
}
function Us(n) {
  const { min: t, max: e, minDefined: i, maxDefined: s } = n.getUserBounds();
  return {
    min: i ? t : Number.NEGATIVE_INFINITY,
    max: s ? e : Number.POSITIVE_INFINITY
  };
}
function Ys(n, t, e) {
  const i = n[t] || (n[t] = {});
  return i[e] || (i[e] = {});
}
function Be(n, t, e, i) {
  for (const s of t.getMatchingVisibleMetas(i).reverse()) {
    const a = n[s.index];
    if (e && a > 0 || !e && a < 0)
      return s.index;
  }
  return null;
}
function Fe(n, t) {
  const { chart: e, _cachedMeta: i } = n, s = e._stacks || (e._stacks = {}), { iScale: a, vScale: o, index: r } = i, h = a.axis, l = o.axis, c = js(a, o, i), d = t.length;
  let u;
  for (let g = 0; g < d; ++g) {
    const f = t[g], { [h]: p, [l]: m } = f, x = f._stacks || (f._stacks = {});
    u = x[l] = Ys(s, c, p), u[r] = m, u._top = Be(u, o, !0, i.type), u._bottom = Be(u, o, !1, i.type);
    const v = u._visualValues || (u._visualValues = {});
    v[r] = m;
  }
}
function ee(n, t) {
  const e = n.scales;
  return Object.keys(e).filter((i) => e[i].axis === t).shift();
}
function Xs(n, t) {
  return ft(n, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function Ks(n, t, e) {
  return ft(n, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: e,
    index: t,
    mode: "default",
    type: "data"
  });
}
function bt(n, t) {
  const e = n.controller.index, i = n.vScale && n.vScale.axis;
  if (i) {
    t = t || n._parsed;
    for (const s of t) {
      const a = s._stacks;
      if (!a || a[i] === void 0 || a[i][e] === void 0)
        return;
      delete a[i][e], a[i]._visualValues !== void 0 && a[i]._visualValues[e] !== void 0 && delete a[i]._visualValues[e];
    }
  }
}
const ie = (n) => n === "reset" || n === "none", $e = (n, t) => t ? n : Object.assign({}, n), qs = (n, t, e) => n && !t.hidden && t._stacked && {
  keys: Li(e, !0),
  values: null
};
class Kt {
  static defaults = {};
  static datasetElementType = null;
  static dataElementType = null;
  constructor(t, e) {
    this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = te(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && bt(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, e = this._cachedMeta, i = this.getDataset(), s = (d, u, g, f) => d === "x" ? u : d === "r" ? f : g, a = e.xAxisID = P(i.xAxisID, ee(t, "x")), o = e.yAxisID = P(i.yAxisID, ee(t, "y")), r = e.rAxisID = P(i.rAxisID, ee(t, "r")), h = e.indexAxis, l = e.iAxisID = s(h, a, o, r), c = e.vAxisID = s(h, o, a, r);
    e.xScale = this.getScaleForId(a), e.yScale = this.getScaleForId(o), e.rScale = this.getScaleForId(r), e.iScale = this.getScaleForId(l), e.vScale = this.getScaleForId(c);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const e = this._cachedMeta;
    return t === e.iScale ? e.vScale : e.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && ve(this._data, this), t._stacked && bt(t);
  }
  _dataCheck() {
    const t = this.getDataset(), e = t.data || (t.data = []), i = this._data;
    if (E(e)) {
      const s = this._cachedMeta;
      this._data = Ns(e, s);
    } else if (i !== e) {
      if (i) {
        ve(i, this);
        const s = this._cachedMeta;
        bt(s), s._parsed = [];
      }
      e && Object.isExtensible(e) && ts(e, this), this._syncList = [], this._data = e;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const e = this._cachedMeta, i = this.getDataset();
    let s = !1;
    this._dataCheck();
    const a = e._stacked;
    e._stacked = te(e.vScale, e), e.stack !== i.stack && (s = !0, bt(e), e.stack = i.stack), this._resyncElements(t), (s || a !== e._stacked) && (Fe(this, e._parsed), e._stacked = te(e.vScale, e));
  }
  configure() {
    const t = this.chart.config, e = t.datasetScopeKeys(this._type), i = t.getOptionScopes(this.getDataset(), e, !0);
    this.options = t.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, e) {
    const { _cachedMeta: i, _data: s } = this, { iScale: a, _stacked: o } = i, r = a.axis;
    let h = t === 0 && e === s.length ? !0 : i._sorted, l = t > 0 && i._parsed[t - 1], c, d, u;
    if (this._parsing === !1)
      i._parsed = s, i._sorted = !0, u = s;
    else {
      H(s[t]) ? u = this.parseArrayData(i, s, t, e) : E(s[t]) ? u = this.parseObjectData(i, s, t, e) : u = this.parsePrimitiveData(i, s, t, e);
      const g = () => d[r] === null || l && d[r] < l[r];
      for (c = 0; c < e; ++c)
        i._parsed[c + t] = d = u[c], h && (g() && (h = !1), l = d);
      i._sorted = h;
    }
    o && Fe(this, u);
  }
  parsePrimitiveData(t, e, i, s) {
    const { iScale: a, vScale: o } = t, r = a.axis, h = o.axis, l = a.getLabels(), c = a === o, d = new Array(s);
    let u, g, f;
    for (u = 0, g = s; u < g; ++u)
      f = u + i, d[u] = {
        [r]: c || a.parse(l[f], f),
        [h]: o.parse(e[f], f)
      };
    return d;
  }
  parseArrayData(t, e, i, s) {
    const { xScale: a, yScale: o } = t, r = new Array(s);
    let h, l, c, d;
    for (h = 0, l = s; h < l; ++h)
      c = h + i, d = e[c], r[h] = {
        x: a.parse(d[0], c),
        y: o.parse(d[1], c)
      };
    return r;
  }
  parseObjectData(t, e, i, s) {
    const { xScale: a, yScale: o } = t, { xAxisKey: r = "x", yAxisKey: h = "y" } = this._parsing, l = new Array(s);
    let c, d, u, g;
    for (c = 0, d = s; c < d; ++c)
      u = c + i, g = e[u], l[c] = {
        x: a.parse(ut(g, r), u),
        y: o.parse(ut(g, h), u)
      };
    return l;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, e, i) {
    const s = this.chart, a = this._cachedMeta, o = e[t.axis], r = {
      keys: Li(s, !0),
      values: e._stacks[t.axis]._visualValues
    };
    return ze(r, o, a.index, {
      mode: i
    });
  }
  updateRangeFromParsed(t, e, i, s) {
    const a = i[e.axis];
    let o = a === null ? NaN : a;
    const r = s && i._stacks[e.axis];
    s && r && (s.values = r, o = ze(s, a, this._cachedMeta.index)), t.min = Math.min(t.min, o), t.max = Math.max(t.max, o);
  }
  getMinMax(t, e) {
    const i = this._cachedMeta, s = i._parsed, a = i._sorted && t === i.iScale, o = s.length, r = this._getOtherScale(t), h = qs(e, i, this.chart), l = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: c, max: d } = Us(r);
    let u, g;
    function f() {
      g = s[u];
      const p = g[r.axis];
      return !N(g[t.axis]) || c > p || d < p;
    }
    for (u = 0; u < o && !(!f() && (this.updateRangeFromParsed(l, t, g, h), a)); ++u)
      ;
    if (a) {
      for (u = o - 1; u >= 0; --u)
        if (!f()) {
          this.updateRangeFromParsed(l, t, g, h);
          break;
        }
    }
    return l;
  }
  getAllParsedValues(t) {
    const e = this._cachedMeta._parsed, i = [];
    let s, a, o;
    for (s = 0, a = e.length; s < a; ++s)
      o = e[s][t.axis], N(o) && i.push(o);
    return i;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, i = e.iScale, s = e.vScale, a = this.getParsed(t);
    return {
      label: i ? "" + i.getLabelForValue(a[i.axis]) : "",
      value: s ? "" + s.getLabelForValue(a[s.axis]) : ""
    };
  }
  _update(t) {
    const e = this._cachedMeta;
    this.update(t || "default"), e._clip = Ws(P(this.options.clip, Vs(e.xScale, e.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, e = this.chart, i = this._cachedMeta, s = i.data || [], a = e.chartArea, o = [], r = this._drawStart || 0, h = this._drawCount || s.length - r, l = this.options.drawActiveElementsOnTop;
    let c;
    for (i.dataset && i.dataset.draw(t, a, r, h), c = r; c < r + h; ++c) {
      const d = s[c];
      d.hidden || (d.active && l ? o.push(d) : d.draw(t, a));
    }
    for (c = 0; c < o.length; ++c)
      o[c].draw(t, a);
  }
  getStyle(t, e) {
    const i = e ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(t || 0, i);
  }
  getContext(t, e, i) {
    const s = this.getDataset();
    let a;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const o = this._cachedMeta.data[t];
      a = o.$context || (o.$context = Ks(this.getContext(), t, o)), a.parsed = this.getParsed(t), a.raw = s.data[t], a.index = a.dataIndex = t;
    } else
      a = this.$context || (this.$context = Xs(this.chart.getContext(), this.index)), a.dataset = s, a.index = a.datasetIndex = this.index;
    return a.active = !!e, a.mode = i, a;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, e) {
    return this._resolveElementOptions(this.dataElementType.id, e, t);
  }
  _resolveElementOptions(t, e = "default", i) {
    const s = e === "active", a = this._cachedDataOpts, o = t + "-" + e, r = a[o], h = this.enableOptionSharing && St(i);
    if (r)
      return $e(r, h);
    const l = this.chart.config, c = l.datasetElementScopeKeys(this._type, t), d = s ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], u = l.getOptionScopes(this.getDataset(), c), g = Object.keys(R.elements[t]), f = () => this.getContext(i, s, e), p = l.resolveNamedOptions(u, g, f, d);
    return p.$shared && (p.$shared = h, a[o] = Object.freeze($e(p, h))), p;
  }
  _resolveAnimations(t, e, i) {
    const s = this.chart, a = this._cachedDataOpts, o = `animation-${e}`, r = a[o];
    if (r)
      return r;
    let h;
    if (s.options.animation !== !1) {
      const c = this.chart.config, d = c.datasetAnimationScopeKeys(this._type, e), u = c.getOptionScopes(this.getDataset(), d);
      h = c.createResolver(u, this.getContext(t, i, e));
    }
    const l = new Ii(s, h && h.animations);
    return h && h._cacheable && (a[o] = Object.freeze(l)), l;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, e) {
    return !e || ie(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, e) {
    const i = this.resolveDataElementOptions(t, e), s = this._sharedOptions, a = this.getSharedOptions(i), o = this.includeOptions(e, a) || a !== s;
    return this.updateSharedOptions(a, e, i), {
      sharedOptions: a,
      includeOptions: o
    };
  }
  updateElement(t, e, i, s) {
    ie(s) ? Object.assign(t, i) : this._resolveAnimations(e, s).update(t, i);
  }
  updateSharedOptions(t, e, i) {
    t && !ie(e) && this._resolveAnimations(void 0, e).update(t, i);
  }
  _setStyle(t, e, i, s) {
    t.active = s;
    const a = this.getStyle(e, s);
    this._resolveAnimations(e, i, s).update(t, {
      options: !s && this.getSharedOptions(a) || a
    });
  }
  removeHoverStyle(t, e, i) {
    this._setStyle(t, i, "active", !1);
  }
  setHoverStyle(t, e, i) {
    this._setStyle(t, i, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const e = this._data, i = this._cachedMeta.data;
    for (const [r, h, l] of this._syncList)
      this[r](h, l);
    this._syncList = [];
    const s = i.length, a = e.length, o = Math.min(a, s);
    o && this.parse(0, o), a > s ? this._insertElements(s, a - s, t) : a < s && this._removeElements(a, s - a);
  }
  _insertElements(t, e, i = !0) {
    const s = this._cachedMeta, a = s.data, o = t + e;
    let r;
    const h = (l) => {
      for (l.length += e, r = l.length - 1; r >= o; r--)
        l[r] = l[r - e];
    };
    for (h(a), r = t; r < o; ++r)
      a[r] = new this.dataElementType();
    this._parsing && h(s._parsed), this.parse(t, e), i && this.updateElements(a, t, e, "reset");
  }
  updateElements(t, e, i, s) {
  }
  _removeElements(t, e) {
    const i = this._cachedMeta;
    if (this._parsing) {
      const s = i._parsed.splice(t, e);
      i._stacked && bt(i, s);
    }
    i.data.splice(t, e);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [e, i, s] = t;
      this[e](i, s);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, e) {
    e && this._sync([
      "_removeElements",
      t,
      e
    ]);
    const i = arguments.length - 2;
    i && this._sync([
      "_insertElements",
      t,
      i
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
function Gs(n, t) {
  if (!n._cache.$bar) {
    const e = n.getMatchingVisibleMetas(t);
    let i = [];
    for (let s = 0, a = e.length; s < a; s++)
      i = i.concat(e[s].controller.getAllParsedValues(n));
    n._cache.$bar = ks(i.sort((s, a) => s - a));
  }
  return n._cache.$bar;
}
function Js(n) {
  const t = n.iScale, e = Gs(t, n.type);
  let i = t._length, s, a, o, r;
  const h = () => {
    o === 32767 || o === -32768 || (St(r) && (i = Math.min(i, Math.abs(o - r) || i)), r = o);
  };
  for (s = 0, a = e.length; s < a; ++s)
    o = t.getPixelForValue(e[s]), h();
  for (r = void 0, s = 0, a = t.ticks.length; s < a; ++s)
    o = t.getPixelForTick(s), h();
  return i;
}
function Qs(n, t, e, i) {
  const s = e.barThickness;
  let a, o;
  return L(s) ? (a = t.min * e.categoryPercentage, o = e.barPercentage) : (a = s * i, o = 1), {
    chunk: a / i,
    ratio: o,
    start: t.pixels[n] - a / 2
  };
}
function Zs(n, t, e, i) {
  const s = t.pixels, a = s[n];
  let o = n > 0 ? s[n - 1] : null, r = n < s.length - 1 ? s[n + 1] : null;
  const h = e.categoryPercentage;
  o === null && (o = a - (r === null ? t.end - t.start : r - a)), r === null && (r = a + a - o);
  const l = a - (a - Math.min(o, r)) / 2 * h;
  return {
    chunk: Math.abs(r - o) / 2 * h / i,
    ratio: e.barPercentage,
    start: l
  };
}
function tn(n, t, e, i) {
  const s = e.parse(n[0], i), a = e.parse(n[1], i), o = Math.min(s, a), r = Math.max(s, a);
  let h = o, l = r;
  Math.abs(o) > Math.abs(r) && (h = r, l = o), t[e.axis] = l, t._custom = {
    barStart: h,
    barEnd: l,
    start: s,
    end: a,
    min: o,
    max: r
  };
}
function Ei(n, t, e, i) {
  return H(n) ? tn(n, t, e, i) : t[e.axis] = e.parse(n, i), t;
}
function He(n, t, e, i) {
  const s = n.iScale, a = n.vScale, o = s.getLabels(), r = s === a, h = [];
  let l, c, d, u;
  for (l = e, c = e + i; l < c; ++l)
    u = t[l], d = {}, d[s.axis] = r || s.parse(o[l], l), h.push(Ei(u, d, a, l));
  return h;
}
function se(n) {
  return n && n.barStart !== void 0 && n.barEnd !== void 0;
}
function en(n, t, e) {
  return n !== 0 ? et(n) : (t.isHorizontal() ? 1 : -1) * (t.min >= e ? 1 : -1);
}
function sn(n) {
  let t, e, i, s, a;
  return n.horizontal ? (t = n.base > n.x, e = "left", i = "right") : (t = n.base < n.y, e = "bottom", i = "top"), t ? (s = "end", a = "start") : (s = "start", a = "end"), {
    start: e,
    end: i,
    reverse: t,
    top: s,
    bottom: a
  };
}
function nn(n, t, e, i) {
  let s = t.borderSkipped;
  const a = {};
  if (!s) {
    n.borderSkipped = a;
    return;
  }
  if (s === !0) {
    n.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: o, end: r, reverse: h, top: l, bottom: c } = sn(n);
  s === "middle" && e && (n.enableBorderRadius = !0, (e._top || 0) === i ? s = l : (e._bottom || 0) === i ? s = c : (a[Ve(c, o, r, h)] = !0, s = l)), a[Ve(s, o, r, h)] = !0, n.borderSkipped = a;
}
function Ve(n, t, e, i) {
  return i ? (n = an(n, t, e), n = We(n, e, t)) : n = We(n, t, e), n;
}
function an(n, t, e) {
  return n === t ? e : n === e ? t : n;
}
function We(n, t, e) {
  return n === "start" ? t : n === "end" ? e : n;
}
function on(n, { inflateAmount: t }, e) {
  n.inflateAmount = t === "auto" ? e === 1 ? 0.33 : 0 : t;
}
class xo extends Kt {
  static id = "bar";
  static defaults = {
    datasetElementType: !1,
    dataElementType: "bar",
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: !0,
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "base",
          "width",
          "height"
        ]
      }
    }
  };
  static overrides = {
    scales: {
      _index_: {
        type: "category",
        offset: !0,
        grid: {
          offset: !0
        }
      },
      _value_: {
        type: "linear",
        beginAtZero: !0
      }
    }
  };
  parsePrimitiveData(t, e, i, s) {
    return He(t, e, i, s);
  }
  parseArrayData(t, e, i, s) {
    return He(t, e, i, s);
  }
  parseObjectData(t, e, i, s) {
    const { iScale: a, vScale: o } = t, { xAxisKey: r = "x", yAxisKey: h = "y" } = this._parsing, l = a.axis === "x" ? r : h, c = o.axis === "x" ? r : h, d = [];
    let u, g, f, p;
    for (u = i, g = i + s; u < g; ++u)
      p = e[u], f = {}, f[a.axis] = a.parse(ut(p, l), u), d.push(Ei(ut(p, c), f, o, u));
    return d;
  }
  updateRangeFromParsed(t, e, i, s) {
    super.updateRangeFromParsed(t, e, i, s);
    const a = i._custom;
    a && e === this._cachedMeta.vScale && (t.min = Math.min(t.min, a.min), t.max = Math.max(t.max, a.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { iScale: i, vScale: s } = e, a = this.getParsed(t), o = a._custom, r = se(o) ? "[" + o.start + ", " + o.end + "]" : "" + s.getLabelForValue(a[s.axis]);
    return {
      label: "" + i.getLabelForValue(a[i.axis]),
      value: r
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const e = this._cachedMeta;
    this.updateElements(e.data, 0, e.data.length, t);
  }
  updateElements(t, e, i, s) {
    const a = s === "reset", { index: o, _cachedMeta: { vScale: r } } = this, h = r.getBasePixel(), l = r.isHorizontal(), c = this._getRuler(), { sharedOptions: d, includeOptions: u } = this._getSharedOptions(e, s);
    for (let g = e; g < e + i; g++) {
      const f = this.getParsed(g), p = a || L(f[r.axis]) ? {
        base: h,
        head: h
      } : this._calculateBarValuePixels(g), m = this._calculateBarIndexPixels(g, c), x = (f._stacks || {})[r.axis], v = {
        horizontal: l,
        base: p.base,
        enableBorderRadius: !x || se(f._custom) || o === x._top || o === x._bottom,
        x: l ? p.head : m.center,
        y: l ? m.center : p.head,
        height: l ? m.size : Math.abs(p.size),
        width: l ? Math.abs(p.size) : m.size
      };
      u && (v.options = d || this.resolveDataElementOptions(g, t[g].active ? "active" : s));
      const y = v.options || t[g].options;
      nn(v, y, x, o), on(v, y, c.ratio), this.updateElement(t[g], g, v, s);
    }
  }
  _getStacks(t, e) {
    const { iScale: i } = this._cachedMeta, s = i.getMatchingVisibleMetas(this._type).filter((c) => c.controller.options.grouped), a = i.options.stacked, o = [], r = this._cachedMeta.controller.getParsed(e), h = r && r[i.axis], l = (c) => {
      const d = c._parsed.find((g) => g[i.axis] === h), u = d && d[c.vScale.axis];
      if (L(u) || isNaN(u))
        return !0;
    };
    for (const c of s)
      if (!(e !== void 0 && l(c)) && ((a === !1 || o.indexOf(c.stack) === -1 || a === void 0 && c.stack === void 0) && o.push(c.stack), c.index === t))
        break;
    return o.length || o.push(void 0), o;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getAxisCount() {
    return this._getAxis().length;
  }
  getFirstScaleIdForIndexAxis() {
    const t = this.chart.scales, e = this.chart.options.indexAxis;
    return Object.keys(t).filter((i) => t[i].axis === e).shift();
  }
  _getAxis() {
    const t = {}, e = this.getFirstScaleIdForIndexAxis();
    for (const i of this.chart.data.datasets)
      t[P(this.chart.options.indexAxis === "x" ? i.xAxisID : i.yAxisID, e)] = !0;
    return Object.keys(t);
  }
  _getStackIndex(t, e, i) {
    const s = this._getStacks(t, i), a = e !== void 0 ? s.indexOf(e) : -1;
    return a === -1 ? s.length - 1 : a;
  }
  _getRuler() {
    const t = this.options, e = this._cachedMeta, i = e.iScale, s = [];
    let a, o;
    for (a = 0, o = e.data.length; a < o; ++a)
      s.push(i.getPixelForValue(this.getParsed(a)[i.axis], a));
    const r = t.barThickness;
    return {
      min: r || Js(e),
      pixels: s,
      start: i._startPixel,
      end: i._endPixel,
      stackCount: this._getStackCount(),
      scale: i,
      grouped: t.grouped,
      ratio: r ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: e, _stacked: i, index: s }, options: { base: a, minBarLength: o } } = this, r = a || 0, h = this.getParsed(t), l = h._custom, c = se(l);
    let d = h[e.axis], u = 0, g = i ? this.applyStack(e, h, i) : d, f, p;
    g !== d && (u = g - d, g = d), c && (d = l.barStart, g = l.barEnd - l.barStart, d !== 0 && et(d) !== et(l.barEnd) && (u = 0), u += d);
    const m = !L(a) && !c ? a : u;
    let x = e.getPixelForValue(m);
    if (this.chart.getDataVisibility(t) ? f = e.getPixelForValue(u + g) : f = x, p = f - x, Math.abs(p) < o) {
      p = en(p, e, r) * o, d === r && (x -= p / 2);
      const v = e.getPixelForDecimal(0), y = e.getPixelForDecimal(1), b = Math.min(v, y), _ = Math.max(v, y);
      x = Math.max(Math.min(x, _), b), f = x + p, i && !c && (h._stacks[e.axis]._visualValues[s] = e.getValueForPixel(f) - e.getValueForPixel(x));
    }
    if (x === e.getPixelForValue(r)) {
      const v = et(p) * e.getLineWidthForValue(r) / 2;
      x += v, p -= v;
    }
    return {
      size: p,
      base: x,
      head: f,
      center: f + p / 2
    };
  }
  _calculateBarIndexPixels(t, e) {
    const i = e.scale, s = this.options, a = s.skipNull, o = P(s.maxBarThickness, 1 / 0);
    let r, h;
    const l = this._getAxisCount();
    if (e.grouped) {
      const c = a ? this._getStackCount(t) : e.stackCount, d = s.barThickness === "flex" ? Zs(t, e, s, c * l) : Qs(t, e, s, c * l), u = this.chart.options.indexAxis === "x" ? this.getDataset().xAxisID : this.getDataset().yAxisID, g = this._getAxis().indexOf(P(u, this.getFirstScaleIdForIndexAxis())), f = this._getStackIndex(this.index, this._cachedMeta.stack, a ? t : void 0) + g;
      r = d.start + d.chunk * f + d.chunk / 2, h = Math.min(o, d.chunk * d.ratio);
    } else
      r = i.getPixelForValue(this.getParsed(t)[i.axis], t), h = Math.min(o, e.min * e.ratio);
    return {
      base: r - h / 2,
      head: r + h / 2,
      center: r,
      size: h
    };
  }
  draw() {
    const t = this._cachedMeta, e = t.vScale, i = t.data, s = i.length;
    let a = 0;
    for (; a < s; ++a)
      this.getParsed(a)[e.axis] !== null && !i[a].hidden && i[a].draw(this._ctx);
  }
}
function rn(n, t, e) {
  let i = 1, s = 1, a = 0, o = 0;
  if (t < lt) {
    const r = n, h = r + t, l = Math.cos(r), c = Math.sin(r), d = Math.cos(h), u = Math.sin(h), g = (y, b, _) => ge(y, r, h, !0) ? 1 : Math.max(b, b * e, _, _ * e), f = (y, b, _) => ge(y, r, h, !0) ? -1 : Math.min(b, b * e, _, _ * e), p = g(0, l, d), m = g(Nt, c, u), x = f(Wt, l, d), v = f(Wt + Nt, c, u);
    i = (p - x) / 2, s = (m - v) / 2, a = -(p + x) / 2, o = -(m + v) / 2;
  }
  return {
    ratioX: i,
    ratioY: s,
    offsetX: a,
    offsetY: o
  };
}
class mo extends Kt {
  static id = "doughnut";
  static defaults = {
    datasetElementType: !1,
    dataElementType: "arc",
    animation: {
      animateRotate: !0,
      animateScale: !1
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "circumference",
          "endAngle",
          "innerRadius",
          "outerRadius",
          "startAngle",
          "x",
          "y",
          "offset",
          "borderWidth",
          "spacing"
        ]
      }
    },
    cutout: "50%",
    rotation: 0,
    circumference: 360,
    radius: "100%",
    spacing: 0,
    indexAxis: "r"
  };
  static descriptors = {
    _scriptable: (t) => t !== "spacing",
    _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
  };
  static overrides = {
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          generateLabels(t) {
            const e = t.data;
            if (e.labels.length && e.datasets.length) {
              const { labels: { pointStyle: i, color: s } } = t.legend.options;
              return e.labels.map((a, o) => {
                const r = t.getDatasetMeta(0).controller.getStyle(o);
                return {
                  text: a,
                  fillStyle: r.backgroundColor,
                  strokeStyle: r.borderColor,
                  fontColor: s,
                  lineWidth: r.borderWidth,
                  pointStyle: i,
                  hidden: !t.getDataVisibility(o),
                  index: o
                };
              });
            }
            return [];
          }
        },
        onClick(t, e, i) {
          i.chart.toggleDataVisibility(e.index), i.chart.update();
        }
      }
    }
  };
  constructor(t, e) {
    super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, e) {
    const i = this.getDataset().data, s = this._cachedMeta;
    if (this._parsing === !1)
      s._parsed = i;
    else {
      let a = (h) => +i[h];
      if (E(i[t])) {
        const { key: h = "value" } = this._parsing;
        a = (l) => +ut(i[l], h);
      }
      let o, r;
      for (o = t, r = t + e; o < r; ++o)
        s._parsed[o] = a(o);
    }
  }
  _getRotation() {
    return Q(this.options.rotation - 90);
  }
  _getCircumference() {
    return Q(this.options.circumference);
  }
  _getRotationExtents() {
    let t = lt, e = -lt;
    for (let i = 0; i < this.chart.data.datasets.length; ++i)
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const s = this.chart.getDatasetMeta(i).controller, a = s._getRotation(), o = s._getCircumference();
        t = Math.min(t, a), e = Math.max(e, a + o);
      }
    return {
      rotation: t,
      circumference: e - t
    };
  }
  update(t) {
    const e = this.chart, { chartArea: i } = e, s = this._cachedMeta, a = s.data, o = this.getMaxBorderWidth() + this.getMaxOffset(a) + this.options.spacing, r = Math.max((Math.min(i.width, i.height) - o) / 2, 0), h = Math.min(Qi(this.options.cutout, r), 1), l = this._getRingWeight(this.index), { circumference: c, rotation: d } = this._getRotationExtents(), { ratioX: u, ratioY: g, offsetX: f, offsetY: p } = rn(d, c, h), m = (i.width - o) / u, x = (i.height - o) / g, v = Math.max(Math.min(m, x) / 2, 0), y = Zi(this.options.radius, v), b = Math.max(y * h, 0), _ = (y - b) / this._getVisibleDatasetWeightTotal();
    this.offsetX = f * y, this.offsetY = p * y, s.total = this.calculateTotal(), this.outerRadius = y - _ * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - _ * l, 0), this.updateElements(a, 0, a.length, t);
  }
  _circumference(t, e) {
    const i = this.options, s = this._cachedMeta, a = this._getCircumference();
    return e && i.animation.animateRotate || !this.chart.getDataVisibility(t) || s._parsed[t] === null || s.data[t].hidden ? 0 : this.calculateCircumference(s._parsed[t] * a / lt);
  }
  updateElements(t, e, i, s) {
    const a = s === "reset", o = this.chart, r = o.chartArea, h = o.options.animation, l = (r.left + r.right) / 2, c = (r.top + r.bottom) / 2, d = a && h.animateScale, u = d ? 0 : this.innerRadius, g = d ? 0 : this.outerRadius, { sharedOptions: f, includeOptions: p } = this._getSharedOptions(e, s);
    let m = this._getRotation(), x;
    for (x = 0; x < e; ++x)
      m += this._circumference(x, a);
    for (x = e; x < e + i; ++x) {
      const v = this._circumference(x, a), y = t[x], b = {
        x: l + this.offsetX,
        y: c + this.offsetY,
        startAngle: m,
        endAngle: m + v,
        circumference: v,
        outerRadius: g,
        innerRadius: u
      };
      p && (b.options = f || this.resolveDataElementOptions(x, y.active ? "active" : s)), m += v, this.updateElement(y, x, b, s);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, e = t.data;
    let i = 0, s;
    for (s = 0; s < e.length; s++) {
      const a = t._parsed[s];
      a !== null && !isNaN(a) && this.chart.getDataVisibility(s) && !e[s].hidden && (i += Math.abs(a));
    }
    return i;
  }
  calculateCircumference(t) {
    const e = this._cachedMeta.total;
    return e > 0 && !isNaN(t) ? lt * (Math.abs(t) / e) : 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, i = this.chart, s = i.data.labels || [], a = ki(e._parsed[t], i.options.locale);
    return {
      label: s[t] || "",
      value: a
    };
  }
  getMaxBorderWidth(t) {
    let e = 0;
    const i = this.chart;
    let s, a, o, r, h;
    if (!t) {
      for (s = 0, a = i.data.datasets.length; s < a; ++s)
        if (i.isDatasetVisible(s)) {
          o = i.getDatasetMeta(s), t = o.data, r = o.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (s = 0, a = t.length; s < a; ++s)
      h = r.resolveDataElementOptions(s), h.borderAlign !== "inner" && (e = Math.max(e, h.borderWidth || 0, h.hoverBorderWidth || 0));
    return e;
  }
  getMaxOffset(t) {
    let e = 0;
    for (let i = 0, s = t.length; i < s; ++i) {
      const a = this.resolveDataElementOptions(i);
      e = Math.max(e, a.offset || 0, a.hoverOffset || 0);
    }
    return e;
  }
  _getRingWeightOffset(t) {
    let e = 0;
    for (let i = 0; i < t; ++i)
      this.chart.isDatasetVisible(i) && (e += this._getRingWeight(i));
    return e;
  }
  _getRingWeight(t) {
    return Math.max(P(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
class bo extends Kt {
  static id = "line";
  static defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: !0,
    spanGaps: !1
  };
  static overrides = {
    scales: {
      _index_: {
        type: "category"
      },
      _value_: {
        type: "linear"
      }
    }
  };
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const e = this._cachedMeta, { dataset: i, data: s = [], _dataset: a } = e, o = this.chart._animationsDisabled;
    let { start: r, count: h } = as(e, s, o);
    this._drawStart = r, this._drawCount = h, os(e) && (r = 0, h = s.length), i._chart = this.chart, i._datasetIndex = this.index, i._decimated = !!a._decimated, i.points = s;
    const l = this.resolveDatasetElementOptions(t);
    this.options.showLine || (l.borderWidth = 0), l.segment = this.options.segment, this.updateElement(i, void 0, {
      animated: !o,
      options: l
    }, t), this.updateElements(s, r, h, t);
  }
  updateElements(t, e, i, s) {
    const a = s === "reset", { iScale: o, vScale: r, _stacked: h, _dataset: l } = this._cachedMeta, { sharedOptions: c, includeOptions: d } = this._getSharedOptions(e, s), u = o.axis, g = r.axis, { spanGaps: f, segment: p } = this.options, m = de(f) ? f : Number.POSITIVE_INFINITY, x = this.chart._animationsDisabled || a || s === "none", v = e + i, y = t.length;
    let b = e > 0 && this.getParsed(e - 1);
    for (let _ = 0; _ < y; ++_) {
      const M = t[_], k = x ? M : {};
      if (_ < e || _ >= v) {
        k.skip = !0;
        continue;
      }
      const w = this.getParsed(_), I = L(w[g]), S = k[u] = o.getPixelForValue(w[u], _), D = k[g] = a || I ? r.getBasePixel() : r.getPixelForValue(h ? this.applyStack(r, w, h) : w[g], _);
      k.skip = isNaN(S) || isNaN(D) || I, k.stop = _ > 0 && Math.abs(w[u] - b[u]) > m, p && (k.parsed = w, k.raw = l.data[_]), d && (k.options = c || this.resolveDataElementOptions(_, M.active ? "active" : s)), x || this.updateElement(M, _, k, s), b = w;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.dataset, i = e.options && e.options.borderWidth || 0, s = t.data || [];
    if (!s.length)
      return i;
    const a = s[0].size(this.resolveDataElementOptions(0)), o = s[s.length - 1].size(this.resolveDataElementOptions(s.length - 1));
    return Math.max(i, a, o) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
function hn(n, t, e, i) {
  const { controller: s, data: a, _sorted: o } = n, r = s._cachedMeta.iScale, h = n.dataset && n.dataset.options ? n.dataset.options.spanGaps : null;
  if (r && t === r.axis && t !== "r" && o && a.length) {
    const l = r._reversePixels ? Is : Ls;
    if (i) {
      if (s._sharedOptions) {
        const c = a[0], d = typeof c.getRange == "function" && c.getRange(t);
        if (d) {
          const u = l(a, t, e - d), g = l(a, t, e + d);
          return {
            lo: u.lo,
            hi: g.hi
          };
        }
      }
    } else {
      const c = l(a, t, e);
      if (h) {
        const { vScale: d } = s._cachedMeta, { _parsed: u } = n, g = u.slice(0, c.lo + 1).reverse().findIndex((p) => !L(p[d.axis]));
        c.lo -= Math.max(0, g);
        const f = u.slice(c.hi).findIndex((p) => !L(p[d.axis]));
        c.hi += Math.max(0, f);
      }
      return c;
    }
  }
  return {
    lo: 0,
    hi: a.length - 1
  };
}
function qt(n, t, e, i, s) {
  const a = n.getSortedVisibleDatasetMetas(), o = e[t];
  for (let r = 0, h = a.length; r < h; ++r) {
    const { index: l, data: c } = a[r], { lo: d, hi: u } = hn(a[r], t, o, s);
    for (let g = d; g <= u; ++g) {
      const f = c[g];
      f.skip || i(f, l, g);
    }
  }
}
function ln(n) {
  const t = n.indexOf("x") !== -1, e = n.indexOf("y") !== -1;
  return function(i, s) {
    const a = t ? Math.abs(i.x - s.x) : 0, o = e ? Math.abs(i.y - s.y) : 0;
    return Math.sqrt(Math.pow(a, 2) + Math.pow(o, 2));
  };
}
function ne(n, t, e, i, s) {
  const a = [];
  return !s && !n.isPointInArea(t) || qt(n, e, t, function(o, r, h) {
    !s && !be(o, n.chartArea, 0) || o.inRange(t.x, t.y, i) && a.push({
      element: o,
      datasetIndex: r,
      index: h
    });
  }, !0), a;
}
function cn(n, t, e, i) {
  let s = [];
  function a(o, r, h) {
    const { startAngle: l, endAngle: c } = o.getProps([
      "startAngle",
      "endAngle"
    ], i), { angle: d } = Es(o, {
      x: t.x,
      y: t.y
    });
    ge(d, l, c) && s.push({
      element: o,
      datasetIndex: r,
      index: h
    });
  }
  return qt(n, e, t, a), s;
}
function dn(n, t, e, i, s, a) {
  let o = [];
  const r = ln(e);
  let h = Number.POSITIVE_INFINITY;
  function l(c, d, u) {
    const g = c.inRange(t.x, t.y, s);
    if (i && !g)
      return;
    const f = c.getCenterPoint(s);
    if (!(a || n.isPointInArea(f)) && !g)
      return;
    const p = r(t, f);
    p < h ? (o = [
      {
        element: c,
        datasetIndex: d,
        index: u
      }
    ], h = p) : p === h && o.push({
      element: c,
      datasetIndex: d,
      index: u
    });
  }
  return qt(n, e, t, l), o;
}
function ae(n, t, e, i, s, a) {
  return !a && !n.isPointInArea(t) ? [] : e === "r" && !i ? cn(n, t, e, s) : dn(n, t, e, i, s, a);
}
function Ne(n, t, e, i, s) {
  const a = [], o = e === "x" ? "inXRange" : "inYRange";
  let r = !1;
  return qt(n, e, t, (h, l, c) => {
    h[o] && h[o](t[e], s) && (a.push({
      element: h,
      datasetIndex: l,
      index: c
    }), r = r || h.inRange(t.x, t.y, s));
  }), i && !r ? [] : a;
}
var un = {
  modes: {
    index(n, t, e, i) {
      const s = at(t, n), a = e.axis || "x", o = e.includeInvisible || !1, r = e.intersect ? ne(n, s, a, i, o) : ae(n, s, a, !1, i, o), h = [];
      return r.length ? (n.getSortedVisibleDatasetMetas().forEach((l) => {
        const c = r[0].index, d = l.data[c];
        d && !d.skip && h.push({
          element: d,
          datasetIndex: l.index,
          index: c
        });
      }), h) : [];
    },
    dataset(n, t, e, i) {
      const s = at(t, n), a = e.axis || "xy", o = e.includeInvisible || !1;
      let r = e.intersect ? ne(n, s, a, i, o) : ae(n, s, a, !1, i, o);
      if (r.length > 0) {
        const h = r[0].datasetIndex, l = n.getDatasetMeta(h).data;
        r = [];
        for (let c = 0; c < l.length; ++c)
          r.push({
            element: l[c],
            datasetIndex: h,
            index: c
          });
      }
      return r;
    },
    point(n, t, e, i) {
      const s = at(t, n), a = e.axis || "xy", o = e.includeInvisible || !1;
      return ne(n, s, a, i, o);
    },
    nearest(n, t, e, i) {
      const s = at(t, n), a = e.axis || "xy", o = e.includeInvisible || !1;
      return ae(n, s, a, e.intersect, i, o);
    },
    x(n, t, e, i) {
      const s = at(t, n);
      return Ne(n, s, "x", e.intersect, i);
    },
    y(n, t, e, i) {
      const s = at(t, n);
      return Ne(n, s, "y", e.intersect, i);
    }
  }
};
const Ri = [
  "left",
  "top",
  "right",
  "bottom"
];
function _t(n, t) {
  return n.filter((e) => e.pos === t);
}
function je(n, t) {
  return n.filter((e) => Ri.indexOf(e.pos) === -1 && e.box.axis === t);
}
function yt(n, t) {
  return n.sort((e, i) => {
    const s = t ? i : e, a = t ? e : i;
    return s.weight === a.weight ? s.index - a.index : s.weight - a.weight;
  });
}
function gn(n) {
  const t = [];
  let e, i, s, a, o, r;
  for (e = 0, i = (n || []).length; e < i; ++e)
    s = n[e], { position: a, options: { stack: o, stackWeight: r = 1 } } = s, t.push({
      index: e,
      box: s,
      pos: a,
      horizontal: s.isHorizontal(),
      weight: s.weight,
      stack: o && a + o,
      stackWeight: r
    });
  return t;
}
function fn(n) {
  const t = {};
  for (const e of n) {
    const { stack: i, pos: s, stackWeight: a } = e;
    if (!i || !Ri.includes(s))
      continue;
    const o = t[i] || (t[i] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    o.count++, o.weight += a;
  }
  return t;
}
function pn(n, t) {
  const e = fn(n), { vBoxMaxWidth: i, hBoxMaxHeight: s } = t;
  let a, o, r;
  for (a = 0, o = n.length; a < o; ++a) {
    r = n[a];
    const { fullSize: h } = r.box, l = e[r.stack], c = l && r.stackWeight / l.weight;
    r.horizontal ? (r.width = c ? c * i : h && t.availableWidth, r.height = s) : (r.width = i, r.height = c ? c * s : h && t.availableHeight);
  }
  return e;
}
function xn(n) {
  const t = gn(n), e = yt(t.filter((l) => l.box.fullSize), !0), i = yt(_t(t, "left"), !0), s = yt(_t(t, "right")), a = yt(_t(t, "top"), !0), o = yt(_t(t, "bottom")), r = je(t, "x"), h = je(t, "y");
  return {
    fullSize: e,
    leftAndTop: i.concat(a),
    rightAndBottom: s.concat(h).concat(o).concat(r),
    chartArea: _t(t, "chartArea"),
    vertical: i.concat(s).concat(h),
    horizontal: a.concat(o).concat(r)
  };
}
function Ue(n, t, e, i) {
  return Math.max(n[e], t[e]) + Math.max(n[i], t[i]);
}
function zi(n, t) {
  n.top = Math.max(n.top, t.top), n.left = Math.max(n.left, t.left), n.bottom = Math.max(n.bottom, t.bottom), n.right = Math.max(n.right, t.right);
}
function mn(n, t, e, i) {
  const { pos: s, box: a } = e, o = n.maxPadding;
  if (!E(s)) {
    e.size && (n[s] -= e.size);
    const d = i[e.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, e.horizontal ? a.height : a.width), e.size = d.size / d.count, n[s] += e.size;
  }
  a.getPadding && zi(o, a.getPadding());
  const r = Math.max(0, t.outerWidth - Ue(o, n, "left", "right")), h = Math.max(0, t.outerHeight - Ue(o, n, "top", "bottom")), l = r !== n.w, c = h !== n.h;
  return n.w = r, n.h = h, e.horizontal ? {
    same: l,
    other: c
  } : {
    same: c,
    other: l
  };
}
function bn(n) {
  const t = n.maxPadding;
  function e(i) {
    const s = Math.max(t[i] - n[i], 0);
    return n[i] += s, s;
  }
  n.y += e("top"), n.x += e("left"), e("right"), e("bottom");
}
function _n(n, t) {
  const e = t.maxPadding;
  function i(s) {
    const a = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return s.forEach((o) => {
      a[o] = Math.max(t[o], e[o]);
    }), a;
  }
  return i(n ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Mt(n, t, e, i) {
  const s = [];
  let a, o, r, h, l, c;
  for (a = 0, o = n.length, l = 0; a < o; ++a) {
    r = n[a], h = r.box, h.update(r.width || t.w, r.height || t.h, _n(r.horizontal, t));
    const { same: d, other: u } = mn(t, e, r, i);
    l |= d && s.length, c = c || u, h.fullSize || s.push(r);
  }
  return l && Mt(s, t, e, i) || c;
}
function Lt(n, t, e, i, s) {
  n.top = e, n.left = t, n.right = t + i, n.bottom = e + s, n.width = i, n.height = s;
}
function Ye(n, t, e, i) {
  const s = e.padding;
  let { x: a, y: o } = t;
  for (const r of n) {
    const h = r.box, l = i[r.stack] || {
      placed: 0,
      weight: 1
    }, c = r.stackWeight / l.weight || 1;
    if (r.horizontal) {
      const d = t.w * c, u = l.size || h.height;
      St(l.start) && (o = l.start), h.fullSize ? Lt(h, s.left, o, e.outerWidth - s.right - s.left, u) : Lt(h, t.left + l.placed, o, d, u), l.start = o, l.placed += d, o = h.bottom;
    } else {
      const d = t.h * c, u = l.size || h.width;
      St(l.start) && (a = l.start), h.fullSize ? Lt(h, a, s.top, u, e.outerHeight - s.bottom - s.top) : Lt(h, a, t.top + l.placed, u, d), l.start = a, l.placed += d, a = h.right;
    }
  }
  t.x = a, t.y = o;
}
var V = {
  addBox(n, t) {
    n.boxes || (n.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(e) {
            t.draw(e);
          }
        }
      ];
    }, n.boxes.push(t);
  },
  removeBox(n, t) {
    const e = n.boxes ? n.boxes.indexOf(t) : -1;
    e !== -1 && n.boxes.splice(e, 1);
  },
  configure(n, t, e) {
    t.fullSize = e.fullSize, t.position = e.position, t.weight = e.weight;
  },
  update(n, t, e, i) {
    if (!n)
      return;
    const s = W(n.options.layout.padding), a = Math.max(t - s.width, 0), o = Math.max(e - s.height, 0), r = xn(n.boxes), h = r.vertical, l = r.horizontal;
    C(n.boxes, (p) => {
      typeof p.beforeLayout == "function" && p.beforeLayout();
    });
    const c = h.reduce((p, m) => m.box.options && m.box.options.display === !1 ? p : p + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: e,
      padding: s,
      availableWidth: a,
      availableHeight: o,
      vBoxMaxWidth: a / 2 / c,
      hBoxMaxHeight: o / 2
    }), u = Object.assign({}, s);
    zi(u, W(i));
    const g = Object.assign({
      maxPadding: u,
      w: a,
      h: o,
      x: s.left,
      y: s.top
    }, s), f = pn(h.concat(l), d);
    Mt(r.fullSize, g, d, f), Mt(h, g, d, f), Mt(l, g, d, f) && Mt(h, g, d, f), bn(g), Ye(r.leftAndTop, g, d, f), g.x += g.w, g.y += g.h, Ye(r.rightAndBottom, g, d, f), n.chartArea = {
      left: g.left,
      top: g.top,
      right: g.left + g.w,
      bottom: g.top + g.h,
      height: g.h,
      width: g.w
    }, C(r.chartArea, (p) => {
      const m = p.box;
      Object.assign(m, n.chartArea), m.update(g.w, g.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class Bi {
  acquireContext(t, e) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, e, i) {
  }
  removeEventListener(t, e, i) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, e, i, s) {
    return e = Math.max(0, e || t.width), i = i || t.height, {
      width: e,
      height: Math.max(0, s ? Math.floor(e / s) : i)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class yn extends Bi {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Ft = "$chartjs", vn = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Xe = (n) => n === null || n === "";
function wn(n, t) {
  const e = n.style, i = n.getAttribute("height"), s = n.getAttribute("width");
  if (n[Ft] = {
    initial: {
      height: i,
      width: s,
      style: {
        display: e.display,
        height: e.height,
        width: e.width
      }
    }
  }, e.display = e.display || "block", e.boxSizing = e.boxSizing || "border-box", Xe(s)) {
    const a = Te(n, "width");
    a !== void 0 && (n.width = a);
  }
  if (Xe(i))
    if (n.style.height === "")
      n.height = n.width / (t || 2);
    else {
      const a = Te(n, "height");
      a !== void 0 && (n.height = a);
    }
  return n;
}
const Fi = Ts ? {
  passive: !0
} : !1;
function Mn(n, t, e) {
  n && n.addEventListener(t, e, Fi);
}
function kn(n, t, e) {
  n && n.canvas && n.canvas.removeEventListener(t, e, Fi);
}
function Sn(n, t) {
  const e = vn[n.type] || n.type, { x: i, y: s } = at(n, t);
  return {
    type: e,
    chart: t,
    native: n,
    x: i !== void 0 ? i : null,
    y: s !== void 0 ? s : null
  };
}
function jt(n, t) {
  for (const e of n)
    if (e === t || e.contains(t))
      return !0;
}
function Dn(n, t, e) {
  const i = n.canvas, s = new MutationObserver((a) => {
    let o = !1;
    for (const r of a)
      o = o || jt(r.addedNodes, i), o = o && !jt(r.removedNodes, i);
    o && e();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
function Pn(n, t, e) {
  const i = n.canvas, s = new MutationObserver((a) => {
    let o = !1;
    for (const r of a)
      o = o || jt(r.removedNodes, i), o = o && !jt(r.addedNodes, i);
    o && e();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
const Pt = /* @__PURE__ */ new Map();
let Ke = 0;
function $i() {
  const n = window.devicePixelRatio;
  n !== Ke && (Ke = n, Pt.forEach((t, e) => {
    e.currentDevicePixelRatio !== n && t();
  }));
}
function An(n, t) {
  Pt.size || window.addEventListener("resize", $i), Pt.set(n, t);
}
function Cn(n) {
  Pt.delete(n), Pt.size || window.removeEventListener("resize", $i);
}
function On(n, t, e) {
  const i = n.canvas, s = i && Oi(i);
  if (!s)
    return;
  const a = Ti((r, h) => {
    const l = s.clientWidth;
    e(r, h), l < s.clientWidth && e();
  }, window), o = new ResizeObserver((r) => {
    const h = r[0], l = h.contentRect.width, c = h.contentRect.height;
    l === 0 && c === 0 || a(l, c);
  });
  return o.observe(s), An(n, a), o;
}
function oe(n, t, e) {
  e && e.disconnect(), t === "resize" && Cn(n);
}
function Tn(n, t, e) {
  const i = n.canvas, s = Ti((a) => {
    n.ctx !== null && e(Sn(a, n));
  }, n);
  return Mn(i, t, s), s;
}
class In extends Bi {
  acquireContext(t, e) {
    const i = t && t.getContext && t.getContext("2d");
    return i && i.canvas === t ? (wn(t, e), i) : null;
  }
  releaseContext(t) {
    const e = t.canvas;
    if (!e[Ft])
      return !1;
    const i = e[Ft].initial;
    [
      "height",
      "width"
    ].forEach((a) => {
      const o = i[a];
      L(o) ? e.removeAttribute(a) : e.setAttribute(a, o);
    });
    const s = i.style || {};
    return Object.keys(s).forEach((a) => {
      e.style[a] = s[a];
    }), e.width = e.width, delete e[Ft], !0;
  }
  addEventListener(t, e, i) {
    this.removeEventListener(t, e);
    const s = t.$proxies || (t.$proxies = {}), a = {
      attach: Dn,
      detach: Pn,
      resize: On
    }[e] || Tn;
    s[e] = a(t, e, i);
  }
  removeEventListener(t, e) {
    const i = t.$proxies || (t.$proxies = {}), s = i[e];
    s && (({
      attach: oe,
      detach: oe,
      resize: oe
    }[e] || kn)(t, e, s), i[e] = void 0);
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, e, i, s) {
    return Ms(t, e, i, s);
  }
  isAttached(t) {
    const e = t && Oi(t);
    return !!(e && e.isConnected);
  }
}
function Ln(n) {
  return !Ci() || typeof OffscreenCanvas < "u" && n instanceof OffscreenCanvas ? yn : In;
}
class it {
  static defaults = {};
  static defaultRoutes = void 0;
  x;
  y;
  active = !1;
  options;
  $animations;
  tooltipPosition(t) {
    const { x: e, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: i
    };
  }
  hasValue() {
    return de(this.x) && de(this.y);
  }
  getProps(t, e) {
    const i = this.$animations;
    if (!e || !i)
      return this;
    const s = {};
    return t.forEach((a) => {
      s[a] = i[a] && i[a].active() ? i[a]._to : this[a];
    }), s;
  }
}
function En(n, t) {
  const e = n.options.ticks, i = Rn(n), s = Math.min(e.maxTicksLimit || i, i), a = e.major.enabled ? Bn(t) : [], o = a.length, r = a[0], h = a[o - 1], l = [];
  if (o > s)
    return Fn(t, l, a, o / s), l;
  const c = zn(a, t, s);
  if (o > 0) {
    let d, u;
    const g = o > 1 ? Math.round((h - r) / (o - 1)) : null;
    for (Et(t, l, c, L(g) ? 0 : r - g, r), d = 0, u = o - 1; d < u; d++)
      Et(t, l, c, a[d], a[d + 1]);
    return Et(t, l, c, h, L(g) ? t.length : h + g), l;
  }
  return Et(t, l, c), l;
}
function Rn(n) {
  const t = n.options.offset, e = n._tickSize(), i = n._length / e + (t ? 0 : 1), s = n._maxLength / e;
  return Math.floor(Math.min(i, s));
}
function zn(n, t, e) {
  const i = $n(n), s = t.length / e;
  if (!i)
    return Math.max(s, 1);
  const a = As(i);
  for (let o = 0, r = a.length - 1; o < r; o++) {
    const h = a[o];
    if (h > s)
      return h;
  }
  return Math.max(s, 1);
}
function Bn(n) {
  const t = [];
  let e, i;
  for (e = 0, i = n.length; e < i; e++)
    n[e].major && t.push(e);
  return t;
}
function Fn(n, t, e, i) {
  let s = 0, a = e[0], o;
  for (i = Math.ceil(i), o = 0; o < n.length; o++)
    o === a && (t.push(n[o]), s++, a = e[s * i]);
}
function Et(n, t, e, i, s) {
  const a = P(i, 0), o = Math.min(P(s, n.length), n.length);
  let r = 0, h, l, c;
  for (e = Math.ceil(e), s && (h = s - i, e = h / Math.floor(h / e)), c = a; c < 0; )
    r++, c = Math.round(a + r * e);
  for (l = Math.max(a, 0); l < o; l++)
    l === c && (t.push(n[l]), r++, c = Math.round(a + r * e));
}
function $n(n) {
  const t = n.length;
  let e, i;
  if (t < 2)
    return !1;
  for (i = n[0], e = 1; e < t; ++e)
    if (n[e] - n[e - 1] !== i)
      return !1;
  return i;
}
const Hn = (n) => n === "left" ? "right" : n === "right" ? "left" : n, qe = (n, t, e) => t === "top" || t === "left" ? n[t] + e : n[t] - e, Ge = (n, t) => Math.min(t || n, n);
function Je(n, t) {
  const e = [], i = n.length / t, s = n.length;
  let a = 0;
  for (; a < s; a += i)
    e.push(n[Math.floor(a)]);
  return e;
}
function Vn(n, t, e) {
  const i = n.ticks.length, s = Math.min(t, i - 1), a = n._startPixel, o = n._endPixel, r = 1e-6;
  let h = n.getPixelForTick(s), l;
  if (!(e && (i === 1 ? l = Math.max(h - a, o - h) : t === 0 ? l = (n.getPixelForTick(1) - h) / 2 : l = (h - n.getPixelForTick(s - 1)) / 2, h += s < t ? l : -l, h < a - r || h > o + r)))
    return h;
}
function Wn(n, t) {
  C(n, (e) => {
    const i = e.gc, s = i.length / 2;
    let a;
    if (s > t) {
      for (a = 0; a < s; ++a)
        delete e.data[i[a]];
      i.splice(0, s);
    }
  });
}
function vt(n) {
  return n.drawTicks ? n.tickLength : 0;
}
function Qe(n, t) {
  if (!n.display)
    return 0;
  const e = F(n.font, t), i = W(n.padding);
  return (H(n.text) ? n.text.length : 1) * e.lineHeight + i.height;
}
function Nn(n, t) {
  return ft(n, {
    scale: t,
    type: "scale"
  });
}
function jn(n, t, e) {
  return ft(n, {
    tick: e,
    index: t,
    type: "tick"
  });
}
function Un(n, t, e) {
  let i = _e(n);
  return (e && t !== "right" || !e && t === "right") && (i = Hn(i)), i;
}
function Yn(n, t, e, i) {
  const { top: s, left: a, bottom: o, right: r, chart: h } = n, { chartArea: l, scales: c } = h;
  let d = 0, u, g, f;
  const p = o - s, m = r - a;
  if (n.isHorizontal()) {
    if (g = B(i, a, r), E(e)) {
      const x = Object.keys(e)[0], v = e[x];
      f = c[x].getPixelForValue(v) + p - t;
    } else e === "center" ? f = (l.bottom + l.top) / 2 + p - t : f = qe(n, e, t);
    u = r - a;
  } else {
    if (E(e)) {
      const x = Object.keys(e)[0], v = e[x];
      g = c[x].getPixelForValue(v) - m + t;
    } else e === "center" ? g = (l.left + l.right) / 2 - m + t : g = qe(n, e, t);
    f = B(i, o, s), d = e === "left" ? -Nt : Nt;
  }
  return {
    titleX: g,
    titleY: f,
    maxWidth: u,
    rotation: d
  };
}
class At extends it {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, e) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: e, _suggestedMin: i, _suggestedMax: s } = this;
    return t = Y(t, Number.POSITIVE_INFINITY), e = Y(e, Number.NEGATIVE_INFINITY), i = Y(i, Number.POSITIVE_INFINITY), s = Y(s, Number.NEGATIVE_INFINITY), {
      min: Y(t, i),
      max: Y(e, s),
      minDefined: N(t),
      maxDefined: N(e)
    };
  }
  getMinMax(t) {
    let { min: e, max: i, minDefined: s, maxDefined: a } = this.getUserBounds(), o;
    if (s && a)
      return {
        min: e,
        max: i
      };
    const r = this.getMatchingVisibleMetas();
    for (let h = 0, l = r.length; h < l; ++h)
      o = r[h].controller.getMinMax(this, t), s || (e = Math.min(e, o.min)), a || (i = Math.max(i, o.max));
    return e = a && e > i ? i : e, i = s && e > i ? e : i, {
      min: Y(e, Y(i, e)),
      max: Y(i, Y(e, i))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    T(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, e, i) {
    const { beginAtZero: s, grace: a, ticks: o } = this.options, r = o.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = i = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = gs(this, a, s), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const h = r < this.ticks.length;
    this._convertTicksToLabels(h ? Je(this.ticks, r) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), o.display && (o.autoSkip || o.source === "auto") && (this.ticks = En(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), h && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, e, i;
    this.isHorizontal() ? (e = this.left, i = this.right) : (e = this.top, i = this.bottom, t = !t), this._startPixel = e, this._endPixel = i, this._reversePixels = t, this._length = i - e, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    T(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    T(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    T(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), T(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    T(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const e = this.options.ticks;
    let i, s, a;
    for (i = 0, s = t.length; i < s; i++)
      a = t[i], a.label = T(e.callback, [
        a.value,
        i,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    T(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    T(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, e = t.ticks, i = Ge(this.ticks.length, t.ticks.maxTicksLimit), s = e.minRotation || 0, a = e.maxRotation;
    let o = s, r, h, l;
    if (!this._isVisible() || !e.display || s >= a || i <= 1 || !this.isHorizontal()) {
      this.labelRotation = s;
      return;
    }
    const c = this._getLabelSizes(), d = c.widest.width, u = c.highest.height, g = Z(this.chart.width - d, 0, this.maxWidth);
    r = t.offset ? this.maxWidth / i : g / (i - 1), d + 6 > r && (r = g / (i - (t.offset ? 0.5 : 1)), h = this.maxHeight - vt(t.grid) - e.padding - Qe(t.title, this.chart.options.font), l = Math.sqrt(d * d + u * u), o = fs(Math.min(Math.asin(Z((c.highest.height + 6) / r, -1, 1)), Math.asin(Z(h / l, -1, 1)) - Math.asin(Z(u / l, -1, 1)))), o = Math.max(s, Math.min(a, o))), this.labelRotation = o;
  }
  afterCalculateLabelRotation() {
    T(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    T(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: e, options: { ticks: i, title: s, grid: a } } = this, o = this._isVisible(), r = this.isHorizontal();
    if (o) {
      const h = Qe(s, e.options.font);
      if (r ? (t.width = this.maxWidth, t.height = vt(a) + h) : (t.height = this.maxHeight, t.width = vt(a) + h), i.display && this.ticks.length) {
        const { first: l, last: c, widest: d, highest: u } = this._getLabelSizes(), g = i.padding * 2, f = Q(this.labelRotation), p = Math.cos(f), m = Math.sin(f);
        if (r) {
          const x = i.mirror ? 0 : m * d.width + p * u.height;
          t.height = Math.min(this.maxHeight, t.height + x + g);
        } else {
          const x = i.mirror ? 0 : p * d.width + m * u.height;
          t.width = Math.min(this.maxWidth, t.width + x + g);
        }
        this._calculatePadding(l, c, m, p);
      }
    }
    this._handleMargins(), r ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, e, i, s) {
    const { ticks: { align: a, padding: o }, position: r } = this.options, h = this.labelRotation !== 0, l = r !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const c = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let u = 0, g = 0;
      h ? l ? (u = s * t.width, g = i * e.height) : (u = i * t.height, g = s * e.width) : a === "start" ? g = e.width : a === "end" ? u = t.width : a !== "inner" && (u = t.width / 2, g = e.width / 2), this.paddingLeft = Math.max((u - c + o) * this.width / (this.width - c), 0), this.paddingRight = Math.max((g - d + o) * this.width / (this.width - d), 0);
    } else {
      let c = e.height / 2, d = t.height / 2;
      a === "start" ? (c = 0, d = t.height) : a === "end" && (c = e.height, d = 0), this.paddingTop = c + o, this.paddingBottom = d + o;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    T(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: e } = this.options;
    return e === "top" || e === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let e, i;
    for (e = 0, i = t.length; e < i; e++)
      L(t[e].label) && (t.splice(e, 1), i--, e--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const e = this.options.ticks.sampleSize;
      let i = this.ticks;
      e < i.length && (i = Je(i, e)), this._labelSizes = t = this._computeLabelSizes(i, i.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, e, i) {
    const { ctx: s, _longestTextCache: a } = this, o = [], r = [], h = Math.floor(e / Ge(e, i));
    let l = 0, c = 0, d, u, g, f, p, m, x, v, y, b, _;
    for (d = 0; d < e; d += h) {
      if (f = t[d].label, p = this._resolveTickFontOptions(d), s.font = m = p.string, x = a[m] = a[m] || {
        data: {},
        gc: []
      }, v = p.lineHeight, y = b = 0, !L(f) && !H(f))
        y = Ce(s, x.data, x.gc, y, f), b = v;
      else if (H(f))
        for (u = 0, g = f.length; u < g; ++u)
          _ = f[u], !L(_) && !H(_) && (y = Ce(s, x.data, x.gc, y, _), b += v);
      o.push(y), r.push(b), l = Math.max(y, l), c = Math.max(b, c);
    }
    Wn(a, e);
    const M = o.indexOf(l), k = r.indexOf(c), w = (I) => ({
      width: o[I] || 0,
      height: r[I] || 0
    });
    return {
      first: w(0),
      last: w(e - 1),
      widest: w(M),
      highest: w(k),
      widths: o,
      heights: r
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, e) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const e = this._startPixel + t * this._length;
    return ps(this._alignToPixels ? nt(this.chart, e, 0) : e);
  }
  getDecimalForPixel(t) {
    const e = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - e : e;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: e } = this;
    return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
  }
  getContext(t) {
    const e = this.ticks || [];
    if (t >= 0 && t < e.length) {
      const i = e[t];
      return i.$context || (i.$context = jn(this.getContext(), t, i));
    }
    return this.$context || (this.$context = Nn(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, e = Q(this.labelRotation), i = Math.abs(Math.cos(e)), s = Math.abs(Math.sin(e)), a = this._getLabelSizes(), o = t.autoSkipPadding || 0, r = a ? a.widest.width + o : 0, h = a ? a.highest.height + o : 0;
    return this.isHorizontal() ? h * i > r * s ? r / i : h / s : h * s < r * i ? h / i : r / s;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const e = this.axis, i = this.chart, s = this.options, { grid: a, position: o, border: r } = s, h = a.offset, l = this.isHorizontal(), c = this.ticks.length + (h ? 1 : 0), d = vt(a), u = [], g = r.setContext(this.getContext()), f = g.display ? g.width : 0, p = f / 2, m = function(A) {
      return nt(i, A, f);
    };
    let x, v, y, b, _, M, k, w, I, S, D, O;
    if (o === "top")
      x = m(this.bottom), M = this.bottom - d, w = x - p, S = m(t.top) + p, O = t.bottom;
    else if (o === "bottom")
      x = m(this.top), S = t.top, O = m(t.bottom) - p, M = x + p, w = this.top + d;
    else if (o === "left")
      x = m(this.right), _ = this.right - d, k = x - p, I = m(t.left) + p, D = t.right;
    else if (o === "right")
      x = m(this.left), I = t.left, D = m(t.right) - p, _ = x + p, k = this.left + d;
    else if (e === "x") {
      if (o === "center")
        x = m((t.top + t.bottom) / 2 + 0.5);
      else if (E(o)) {
        const A = Object.keys(o)[0], z = o[A];
        x = m(this.chart.scales[A].getPixelForValue(z));
      }
      S = t.top, O = t.bottom, M = x + p, w = M + d;
    } else if (e === "y") {
      if (o === "center")
        x = m((t.left + t.right) / 2);
      else if (E(o)) {
        const A = Object.keys(o)[0], z = o[A];
        x = m(this.chart.scales[A].getPixelForValue(z));
      }
      _ = x - p, k = _ - d, I = t.left, D = t.right;
    }
    const j = P(s.ticks.maxTicksLimit, c), U = Math.max(1, Math.ceil(c / j));
    for (v = 0; v < c; v += U) {
      const A = this.getContext(v), z = a.setContext(A), Ct = r.setContext(A), Ot = z.lineWidth, Jt = z.color, rt = Ct.dash || [], Tt = Ct.dashOffset, ht = z.tickWidth, pt = z.tickColor, st = z.tickBorderDash || [], xt = z.tickBorderDashOffset;
      y = Vn(this, v, h), y !== void 0 && (b = nt(i, y, Ot), l ? _ = k = I = D = b : M = w = S = O = b, u.push({
        tx1: _,
        ty1: M,
        tx2: k,
        ty2: w,
        x1: I,
        y1: S,
        x2: D,
        y2: O,
        width: Ot,
        color: Jt,
        borderDash: rt,
        borderDashOffset: Tt,
        tickWidth: ht,
        tickColor: pt,
        tickBorderDash: st,
        tickBorderDashOffset: xt
      }));
    }
    return this._ticksLength = c, this._borderValue = x, u;
  }
  _computeLabelItems(t) {
    const e = this.axis, i = this.options, { position: s, ticks: a } = i, o = this.isHorizontal(), r = this.ticks, { align: h, crossAlign: l, padding: c, mirror: d } = a, u = vt(i.grid), g = u + c, f = d ? -c : g, p = -Q(this.labelRotation), m = [];
    let x, v, y, b, _, M, k, w, I, S, D, O, j = "middle";
    if (s === "top")
      M = this.bottom - f, k = this._getXAxisLabelAlignment();
    else if (s === "bottom")
      M = this.top + f, k = this._getXAxisLabelAlignment();
    else if (s === "left") {
      const A = this._getYAxisLabelAlignment(u);
      k = A.textAlign, _ = A.x;
    } else if (s === "right") {
      const A = this._getYAxisLabelAlignment(u);
      k = A.textAlign, _ = A.x;
    } else if (e === "x") {
      if (s === "center")
        M = (t.top + t.bottom) / 2 + g;
      else if (E(s)) {
        const A = Object.keys(s)[0], z = s[A];
        M = this.chart.scales[A].getPixelForValue(z) + g;
      }
      k = this._getXAxisLabelAlignment();
    } else if (e === "y") {
      if (s === "center")
        _ = (t.left + t.right) / 2 - g;
      else if (E(s)) {
        const A = Object.keys(s)[0], z = s[A];
        _ = this.chart.scales[A].getPixelForValue(z);
      }
      k = this._getYAxisLabelAlignment(u).textAlign;
    }
    e === "y" && (h === "start" ? j = "top" : h === "end" && (j = "bottom"));
    const U = this._getLabelSizes();
    for (x = 0, v = r.length; x < v; ++x) {
      y = r[x], b = y.label;
      const A = a.setContext(this.getContext(x));
      w = this.getPixelForTick(x) + a.labelOffset, I = this._resolveTickFontOptions(x), S = I.lineHeight, D = H(b) ? b.length : 1;
      const z = D / 2, Ct = A.color, Ot = A.textStrokeColor, Jt = A.textStrokeWidth;
      let rt = k;
      o ? (_ = w, k === "inner" && (x === v - 1 ? rt = this.options.reverse ? "left" : "right" : x === 0 ? rt = this.options.reverse ? "right" : "left" : rt = "center"), s === "top" ? l === "near" || p !== 0 ? O = -D * S + S / 2 : l === "center" ? O = -U.highest.height / 2 - z * S + S : O = -U.highest.height + S / 2 : l === "near" || p !== 0 ? O = S / 2 : l === "center" ? O = U.highest.height / 2 - z * S : O = U.highest.height - D * S, d && (O *= -1), p !== 0 && !A.showLabelBackdrop && (_ += S / 2 * Math.sin(p))) : (M = w, O = (1 - D) * S / 2);
      let Tt;
      if (A.showLabelBackdrop) {
        const ht = W(A.backdropPadding), pt = U.heights[x], st = U.widths[x];
        let xt = O - ht.top, mt = 0 - ht.left;
        switch (j) {
          case "middle":
            xt -= pt / 2;
            break;
          case "bottom":
            xt -= pt;
            break;
        }
        switch (k) {
          case "center":
            mt -= st / 2;
            break;
          case "right":
            mt -= st;
            break;
          case "inner":
            x === v - 1 ? mt -= st : x > 0 && (mt -= st / 2);
            break;
        }
        Tt = {
          left: mt,
          top: xt,
          width: st + ht.width,
          height: pt + ht.height,
          color: A.backdropColor
        };
      }
      m.push({
        label: b,
        font: I,
        textOffset: O,
        options: {
          rotation: p,
          color: Ct,
          strokeColor: Ot,
          strokeWidth: Jt,
          textAlign: rt,
          textBaseline: j,
          translation: [
            _,
            M
          ],
          backdrop: Tt
        }
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: e } = this.options;
    if (-Q(this.labelRotation))
      return t === "top" ? "left" : "right";
    let i = "center";
    return e.align === "start" ? i = "left" : e.align === "end" ? i = "right" : e.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(t) {
    const { position: e, ticks: { crossAlign: i, mirror: s, padding: a } } = this.options, o = this._getLabelSizes(), r = t + a, h = o.widest.width;
    let l, c;
    return e === "left" ? s ? (c = this.right + a, i === "near" ? l = "left" : i === "center" ? (l = "center", c += h / 2) : (l = "right", c += h)) : (c = this.right - r, i === "near" ? l = "right" : i === "center" ? (l = "center", c -= h / 2) : (l = "left", c = this.left)) : e === "right" ? s ? (c = this.left + a, i === "near" ? l = "right" : i === "center" ? (l = "center", c -= h / 2) : (l = "left", c -= h)) : (c = this.left + r, i === "near" ? l = "left" : i === "center" ? (l = "center", c += h / 2) : (l = "right", c = this.right)) : l = "right", {
      textAlign: l,
      x: c
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, e = this.options.position;
    if (e === "left" || e === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (e === "top" || e === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: e }, left: i, top: s, width: a, height: o } = this;
    e && (t.save(), t.fillStyle = e, t.fillRect(i, s, a, o), t.restore());
  }
  getLineWidthForValue(t) {
    const e = this.options.grid;
    if (!this._isVisible() || !e.display)
      return 0;
    const i = this.ticks.findIndex((s) => s.value === t);
    return i >= 0 ? e.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(t) {
    const e = this.options.grid, i = this.ctx, s = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let a, o;
    const r = (h, l, c) => {
      !c.width || !c.color || (i.save(), i.lineWidth = c.width, i.strokeStyle = c.color, i.setLineDash(c.borderDash || []), i.lineDashOffset = c.borderDashOffset, i.beginPath(), i.moveTo(h.x, h.y), i.lineTo(l.x, l.y), i.stroke(), i.restore());
    };
    if (e.display)
      for (a = 0, o = s.length; a < o; ++a) {
        const h = s[a];
        e.drawOnChartArea && r({
          x: h.x1,
          y: h.y1
        }, {
          x: h.x2,
          y: h.y2
        }, h), e.drawTicks && r({
          x: h.tx1,
          y: h.ty1
        }, {
          x: h.tx2,
          y: h.ty2
        }, {
          color: h.tickColor,
          width: h.tickWidth,
          borderDash: h.tickBorderDash,
          borderDashOffset: h.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: e, options: { border: i, grid: s } } = this, a = i.setContext(this.getContext()), o = i.display ? a.width : 0;
    if (!o)
      return;
    const r = s.setContext(this.getContext(0)).lineWidth, h = this._borderValue;
    let l, c, d, u;
    this.isHorizontal() ? (l = nt(t, this.left, o) - o / 2, c = nt(t, this.right, r) + r / 2, d = u = h) : (d = nt(t, this.top, o) - o / 2, u = nt(t, this.bottom, r) + r / 2, l = c = h), e.save(), e.lineWidth = a.width, e.strokeStyle = a.color, e.beginPath(), e.moveTo(l, d), e.lineTo(c, u), e.stroke(), e.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const e = this.ctx, i = this._computeLabelArea();
    i && Yt(e, i);
    const s = this.getLabelItems(t);
    for (const a of s) {
      const o = a.options, r = a.font, h = a.label, l = a.textOffset;
      Dt(e, h, 0, l, r, o);
    }
    i && Xt(e);
  }
  drawTitle() {
    const { ctx: t, options: { position: e, title: i, reverse: s } } = this;
    if (!i.display)
      return;
    const a = F(i.font), o = W(i.padding), r = i.align;
    let h = a.lineHeight / 2;
    e === "bottom" || e === "center" || E(e) ? (h += o.bottom, H(i.text) && (h += a.lineHeight * (i.text.length - 1))) : h += o.top;
    const { titleX: l, titleY: c, maxWidth: d, rotation: u } = Yn(this, h, e, r);
    Dt(t, i.text, 0, 0, a, {
      color: i.color,
      maxWidth: d,
      rotation: u,
      textAlign: Un(r, e, s),
      textBaseline: "middle",
      translation: [
        l,
        c
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, e = t.ticks && t.ticks.z || 0, i = P(t.grid && t.grid.z, -1), s = P(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== At.prototype.draw ? [
      {
        z: e,
        draw: (a) => {
          this.draw(a);
        }
      }
    ] : [
      {
        z: i,
        draw: (a) => {
          this.drawBackground(), this.drawGrid(a), this.drawTitle();
        }
      },
      {
        z: s,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: e,
        draw: (a) => {
          this.drawLabels(a);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const e = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", s = [];
    let a, o;
    for (a = 0, o = e.length; a < o; ++a) {
      const r = e[a];
      r[i] === this.id && (!t || r.type === t) && s.push(r);
    }
    return s;
  }
  _resolveTickFontOptions(t) {
    const e = this.options.ticks.setContext(this.getContext(t));
    return F(e.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Rt {
  constructor(t, e, i) {
    this.type = t, this.scope = e, this.override = i, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const e = Object.getPrototypeOf(t);
    let i;
    qn(e) && (i = this.register(e));
    const s = this.items, a = t.id, o = this.scope + "." + a;
    if (!a)
      throw new Error("class does not have id: " + t);
    return a in s || (s[a] = t, Xn(t, o, i), this.override && R.override(t.id, t.overrides)), o;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const e = this.items, i = t.id, s = this.scope;
    i in e && delete e[i], s && i in R[s] && (delete R[s][i], this.override && delete gt[i]);
  }
}
function Xn(n, t, e) {
  const i = Ps(/* @__PURE__ */ Object.create(null), [
    e ? R.get(e) : {},
    R.get(t),
    n.defaults
  ]);
  R.set(t, i), n.defaultRoutes && Kn(t, n.defaultRoutes), n.descriptors && R.describe(t, n.descriptors);
}
function Kn(n, t) {
  Object.keys(t).forEach((e) => {
    const i = e.split("."), s = i.pop(), a = [
      n
    ].concat(i).join("."), o = t[e].split("."), r = o.pop(), h = o.join(".");
    R.route(a, s, h, r);
  });
}
function qn(n) {
  return "id" in n && "defaults" in n;
}
class Gn {
  constructor() {
    this.controllers = new Rt(Kt, "datasets", !0), this.elements = new Rt(it, "elements"), this.plugins = new Rt(Object, "plugins"), this.scales = new Rt(At, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, i) {
    [
      ...e
    ].forEach((s) => {
      const a = i || this._getRegistryForType(s);
      i || a.isForType(s) || a === this.plugins && s.id ? this._exec(t, a, s) : C(s, (o) => {
        const r = i || this._getRegistryForType(o);
        this._exec(t, r, o);
      });
    });
  }
  _exec(t, e, i) {
    const s = us(t);
    T(i["before" + s], [], i), e[t](i), T(i["after" + s], [], i);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const i = this._typedRegistries[e];
      if (i.isForType(t))
        return i;
    }
    return this.plugins;
  }
  _get(t, e, i) {
    const s = e.get(t);
    if (s === void 0)
      throw new Error('"' + t + '" is not a registered ' + i + ".");
    return s;
  }
}
var K = /* @__PURE__ */ new Gn();
class Jn {
  constructor() {
    this._init = [];
  }
  notify(t, e, i, s) {
    e === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const a = s ? this._descriptors(t).filter(s) : this._descriptors(t), o = this._notify(a, t, e, i);
    return e === "afterDestroy" && (this._notify(a, t, "stop"), this._notify(this._init, t, "uninstall")), o;
  }
  _notify(t, e, i, s) {
    s = s || {};
    for (const a of t) {
      const o = a.plugin, r = o[i], h = [
        e,
        s,
        a.options
      ];
      if (T(r, h, o) === !1 && s.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    L(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const e = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), e;
  }
  _createDescriptors(t, e) {
    const i = t && t.config, s = P(i.options && i.options.plugins, {}), a = Qn(i);
    return s === !1 && !e ? [] : ta(t, a, s, e);
  }
  _notifyStateChanges(t) {
    const e = this._oldCache || [], i = this._cache, s = (a, o) => a.filter((r) => !o.some((h) => r.plugin.id === h.plugin.id));
    this._notify(s(e, i), t, "stop"), this._notify(s(i, e), t, "start");
  }
}
function Qn(n) {
  const t = {}, e = [], i = Object.keys(K.plugins.items);
  for (let a = 0; a < i.length; a++)
    e.push(K.getPlugin(i[a]));
  const s = n.plugins || [];
  for (let a = 0; a < s.length; a++) {
    const o = s[a];
    e.indexOf(o) === -1 && (e.push(o), t[o.id] = !0);
  }
  return {
    plugins: e,
    localIds: t
  };
}
function Zn(n, t) {
  return !t && n === !1 ? null : n === !0 ? {} : n;
}
function ta(n, { plugins: t, localIds: e }, i, s) {
  const a = [], o = n.getContext();
  for (const r of t) {
    const h = r.id, l = Zn(i[h], s);
    l !== null && a.push({
      plugin: r,
      options: ea(n.config, {
        plugin: r,
        local: e[h]
      }, l, o)
    });
  }
  return a;
}
function ea(n, { plugin: t, local: e }, i, s) {
  const a = n.pluginScopeKeys(t), o = n.getOptionScopes(i, a);
  return e && t.defaults && o.push(t.defaults), n.createResolver(o, s, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function fe(n, t) {
  const e = R.datasets[n] || {};
  return ((t.datasets || {})[n] || {}).indexAxis || t.indexAxis || e.indexAxis || "x";
}
function ia(n, t) {
  let e = n;
  return n === "_index_" ? e = t : n === "_value_" && (e = t === "x" ? "y" : "x"), e;
}
function sa(n, t) {
  return n === t ? "_index_" : "_value_";
}
function Ze(n) {
  if (n === "x" || n === "y" || n === "r")
    return n;
}
function na(n) {
  if (n === "top" || n === "bottom")
    return "x";
  if (n === "left" || n === "right")
    return "y";
}
function pe(n, ...t) {
  if (Ze(n))
    return n;
  for (const e of t) {
    const i = e.axis || na(e.position) || n.length > 1 && Ze(n[0].toLowerCase());
    if (i)
      return i;
  }
  throw new Error(`Cannot determine type of '${n}' axis. Please provide 'axis' or 'position' option.`);
}
function ti(n, t, e) {
  if (e[t + "AxisID"] === n)
    return {
      axis: t
    };
}
function aa(n, t) {
  if (t.data && t.data.datasets) {
    const e = t.data.datasets.filter((i) => i.xAxisID === n || i.yAxisID === n);
    if (e.length)
      return ti(n, "x", e[0]) || ti(n, "y", e[0]);
  }
  return {};
}
function oa(n, t) {
  const e = gt[n.type] || {
    scales: {}
  }, i = t.scales || {}, s = fe(n.type, t), a = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach((o) => {
    const r = i[o];
    if (!E(r))
      return console.error(`Invalid scale configuration for scale: ${o}`);
    if (r._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${o}`);
    const h = pe(o, r, aa(o, n), R.scales[r.type]), l = sa(h, s), c = e.scales || {};
    a[o] = Zt(/* @__PURE__ */ Object.create(null), [
      {
        axis: h
      },
      r,
      c[h],
      c[l]
    ]);
  }), n.data.datasets.forEach((o) => {
    const r = o.type || n.type, h = o.indexAxis || fe(r, t), l = (gt[r] || {}).scales || {};
    Object.keys(l).forEach((c) => {
      const d = ia(c, h), u = o[d + "AxisID"] || d;
      a[u] = a[u] || /* @__PURE__ */ Object.create(null), Zt(a[u], [
        {
          axis: d
        },
        i[u],
        l[c]
      ]);
    });
  }), Object.keys(a).forEach((o) => {
    const r = a[o];
    Zt(r, [
      R.scales[r.type],
      R.scale
    ]);
  }), a;
}
function Hi(n) {
  const t = n.options || (n.options = {});
  t.plugins = P(t.plugins, {}), t.scales = oa(n, t);
}
function Vi(n) {
  return n = n || {}, n.datasets = n.datasets || [], n.labels = n.labels || [], n;
}
function ra(n) {
  return n = n || {}, n.data = Vi(n.data), Hi(n), n;
}
const ei = /* @__PURE__ */ new Map(), Wi = /* @__PURE__ */ new Set();
function zt(n, t) {
  let e = ei.get(n);
  return e || (e = t(), ei.set(n, e), Wi.add(e)), e;
}
const wt = (n, t, e) => {
  const i = ut(t, e);
  i !== void 0 && n.add(i);
};
class ha {
  constructor(t) {
    this._config = ra(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = Vi(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), Hi(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return zt(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, e) {
    return zt(`${t}.transition.${e}`, () => [
      [
        `datasets.${t}.transitions.${e}`,
        `transitions.${e}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, e) {
    return zt(`${t}-${e}`, () => [
      [
        `datasets.${t}.elements.${e}`,
        `datasets.${t}`,
        `elements.${e}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const e = t.id, i = this.type;
    return zt(`${i}-plugin-${e}`, () => [
      [
        `plugins.${e}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, e) {
    const i = this._scopeCache;
    let s = i.get(t);
    return (!s || e) && (s = /* @__PURE__ */ new Map(), i.set(t, s)), s;
  }
  getOptionScopes(t, e, i) {
    const { options: s, type: a } = this, o = this._cachedScopes(t, i), r = o.get(e);
    if (r)
      return r;
    const h = /* @__PURE__ */ new Set();
    e.forEach((c) => {
      t && (h.add(t), c.forEach((d) => wt(h, t, d))), c.forEach((d) => wt(h, s, d)), c.forEach((d) => wt(h, gt[a] || {}, d)), c.forEach((d) => wt(h, R, d)), c.forEach((d) => wt(h, Pe, d));
    });
    const l = Array.from(h);
    return l.length === 0 && l.push(/* @__PURE__ */ Object.create(null)), Wi.has(e) && o.set(e, l), l;
  }
  chartOptionScopes() {
    const { options: t, type: e } = this;
    return [
      t,
      gt[e] || {},
      R.datasets[e] || {},
      {
        type: e
      },
      R,
      Pe
    ];
  }
  resolveNamedOptions(t, e, i, s = [
    ""
  ]) {
    const a = {
      $shared: !0
    }, { resolver: o, subPrefixes: r } = ii(this._resolverCache, t, s);
    let h = o;
    if (ca(o, e)) {
      a.$shared = !1, i = Ut(i) ? i() : i;
      const l = this.createResolver(t, i, r);
      h = Ae(o, i, l);
    }
    for (const l of e)
      a[l] = h[l];
    return a;
  }
  createResolver(t, e, i = [
    ""
  ], s) {
    const { resolver: a } = ii(this._resolverCache, t, i);
    return E(e) ? Ae(a, e, void 0, s) : a;
  }
}
function ii(n, t, e) {
  let i = n.get(t);
  i || (i = /* @__PURE__ */ new Map(), n.set(t, i));
  const s = e.join();
  let a = i.get(s);
  return a || (a = {
    resolver: vs(t, e),
    subPrefixes: e.filter((o) => !o.toLowerCase().includes("hover"))
  }, i.set(s, a)), a;
}
const la = (n) => E(n) && Object.getOwnPropertyNames(n).some((t) => Ut(n[t]));
function ca(n, t) {
  const { isScriptable: e, isIndexable: i } = ws(n);
  for (const s of t) {
    const a = e(s), o = i(s), r = (o || a) && n[s];
    if (a && (Ut(r) || la(r)) || o && H(r))
      return !0;
  }
  return !1;
}
var da = "4.5.0";
const ua = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function si(n, t) {
  return n === "top" || n === "bottom" || ua.indexOf(n) === -1 && t === "x";
}
function ni(n, t) {
  return function(e, i) {
    return e[n] === i[n] ? e[t] - i[t] : e[n] - i[n];
  };
}
function ai(n) {
  const t = n.chart, e = t.options.animation;
  t.notifyPlugins("afterRender"), T(e && e.onComplete, [
    n
  ], t);
}
function ga(n) {
  const t = n.chart, e = t.options.animation;
  T(e && e.onProgress, [
    n
  ], t);
}
function Ni(n) {
  return Ci() && typeof n == "string" ? n = document.getElementById(n) : n && n.length && (n = n[0]), n && n.canvas && (n = n.canvas), n;
}
const $t = {}, oi = (n) => {
  const t = Ni(n);
  return Object.values($t).filter((e) => e.canvas === t).pop();
};
function fa(n, t, e) {
  const i = Object.keys(n);
  for (const s of i) {
    const a = +s;
    if (a >= t) {
      const o = n[s];
      delete n[s], (e > 0 || a > t) && (n[a + e] = o);
    }
  }
}
function pa(n, t, e, i) {
  return !e || n.type === "mouseout" ? null : i ? t : n;
}
class xa {
  static defaults = R;
  static instances = $t;
  static overrides = gt;
  static registry = K;
  static version = da;
  static getChart = oi;
  static register(...t) {
    K.add(...t), ri();
  }
  static unregister(...t) {
    K.remove(...t), ri();
  }
  constructor(t, e) {
    const i = this.config = new ha(e), s = Ni(t), a = oi(s);
    if (a)
      throw new Error("Canvas is already in use. Chart with ID '" + a.id + "' must be destroyed before the canvas with ID '" + a.canvas.id + "' can be reused.");
    const o = i.createResolver(i.chartOptionScopes(), this.getContext());
    this.platform = new (i.platform || Ln(s))(), this.platform.updateConfig(i);
    const r = this.platform.acquireContext(s, o.aspectRatio), h = r && r.canvas, l = h && h.height, c = h && h.width;
    if (this.id = is(), this.ctx = r, this.canvas = h, this.width = c, this.height = l, this._options = o, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new Jn(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = ss((d) => this.update(d), o.resizeDelay || 0), this._dataChanges = [], $t[this.id] = this, !r || !h) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    G.listen(this, "complete", ai), G.listen(this, "progress", ga), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: e }, width: i, height: s, _aspectRatio: a } = this;
    return L(t) ? e && a ? a : s ? i / s : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return K;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : ke(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Se(this.canvas, this.ctx), this;
  }
  stop() {
    return G.stop(this), this;
  }
  resize(t, e) {
    G.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: e
    } : this._resize(t, e);
  }
  _resize(t, e) {
    const i = this.options, s = this.canvas, a = i.maintainAspectRatio && this.aspectRatio, o = this.platform.getMaximumSize(s, t, e, a), r = i.devicePixelRatio || this.platform.getDevicePixelRatio(), h = this.width ? "resize" : "attach";
    this.width = o.width, this.height = o.height, this._aspectRatio = this.aspectRatio, ke(this, r, !0) && (this.notifyPlugins("resize", {
      size: o
    }), T(i.onResize, [
      this,
      o
    ], this), this.attached && this._doResize(h) && this.render());
  }
  ensureScalesHaveIDs() {
    const t = this.options.scales || {};
    C(t, (e, i) => {
      e.id = i;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, e = t.scales, i = this.scales, s = Object.keys(i).reduce((o, r) => (o[r] = !1, o), {});
    let a = [];
    e && (a = a.concat(Object.keys(e).map((o) => {
      const r = e[o], h = pe(o, r), l = h === "r", c = h === "x";
      return {
        options: r,
        dposition: l ? "chartArea" : c ? "bottom" : "left",
        dtype: l ? "radialLinear" : c ? "category" : "linear"
      };
    }))), C(a, (o) => {
      const r = o.options, h = r.id, l = pe(h, r), c = P(r.type, o.dtype);
      (r.position === void 0 || si(r.position, l) !== si(o.dposition)) && (r.position = o.dposition), s[h] = !0;
      let d = null;
      if (h in i && i[h].type === c)
        d = i[h];
      else {
        const u = K.getScale(c);
        d = new u({
          id: h,
          type: c,
          ctx: this.ctx,
          chart: this
        }), i[d.id] = d;
      }
      d.init(r, t);
    }), C(s, (o, r) => {
      o || delete i[r];
    }), C(i, (o) => {
      V.configure(this, o, o.options), V.addBox(this, o);
    });
  }
  _updateMetasets() {
    const t = this._metasets, e = this.data.datasets.length, i = t.length;
    if (t.sort((s, a) => s.index - a.index), i > e) {
      for (let s = e; s < i; ++s)
        this._destroyDatasetMeta(s);
      t.splice(e, i - e);
    }
    this._sortedMetasets = t.slice(0).sort(ni("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: e } } = this;
    t.length > e.length && delete this._stacks, t.forEach((i, s) => {
      e.filter((a) => a === i._dataset).length === 0 && this._destroyDatasetMeta(s);
    });
  }
  buildOrUpdateControllers() {
    const t = [], e = this.data.datasets;
    let i, s;
    for (this._removeUnreferencedMetasets(), i = 0, s = e.length; i < s; i++) {
      const a = e[i];
      let o = this.getDatasetMeta(i);
      const r = a.type || this.config.type;
      if (o.type && o.type !== r && (this._destroyDatasetMeta(i), o = this.getDatasetMeta(i)), o.type = r, o.indexAxis = a.indexAxis || fe(r, this.options), o.order = a.order || 0, o.index = i, o.label = "" + a.label, o.visible = this.isDatasetVisible(i), o.controller)
        o.controller.updateIndex(i), o.controller.linkScales();
      else {
        const h = K.getController(r), { datasetElementType: l, dataElementType: c } = R.datasets[r];
        Object.assign(h, {
          dataElementType: K.getElement(c),
          datasetElementType: l && K.getElement(l)
        }), o.controller = new h(this, i), t.push(o.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    C(this.data.datasets, (t, e) => {
      this.getDatasetMeta(e).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const e = this.config;
    e.update();
    const i = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), s = this._animationsDisabled = !i.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const a = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let o = 0;
    for (let l = 0, c = this.data.datasets.length; l < c; l++) {
      const { controller: d } = this.getDatasetMeta(l), u = !s && a.indexOf(d) === -1;
      d.buildOrUpdateElements(u), o = Math.max(+d.getMaxOverflow(), o);
    }
    o = this._minPadding = i.layout.autoPadding ? o : 0, this._updateLayout(o), s || C(a, (l) => {
      l.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(ni("z", "_idx"));
    const { _active: r, _lastEvent: h } = this;
    h ? this._eventHandler(h, !0) : r.length && this._updateHoverStyles(r, r, !0), this.render();
  }
  _updateScales() {
    C(this.scales, (t) => {
      V.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, e = new Set(Object.keys(this._listeners)), i = new Set(t.events);
    (!De(e, i) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
    for (const { method: i, start: s, count: a } of e) {
      const o = i === "_removeElements" ? -a : a;
      fa(t, s, o);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const e = this.data.datasets.length, i = (a) => new Set(t.filter((o) => o[0] === a).map((o, r) => r + "," + o.splice(1).join(","))), s = i(0);
    for (let a = 1; a < e; a++)
      if (!De(s, i(a)))
        return;
    return Array.from(s).map((a) => a.split(",")).map((a) => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    V.update(this, this.width, this.height, t);
    const e = this.chartArea, i = e.width <= 0 || e.height <= 0;
    this._layers = [], C(this.boxes, (s) => {
      i && s.position === "chartArea" || (s.configure && s.configure(), this._layers.push(...s._layers()));
    }, this), this._layers.forEach((s, a) => {
      s._idx = a;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let e = 0, i = this.data.datasets.length; e < i; ++e)
        this.getDatasetMeta(e).controller.configure();
      for (let e = 0, i = this.data.datasets.length; e < i; ++e)
        this._updateDataset(e, Ut(t) ? t({
          datasetIndex: e
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, e) {
    const i = this.getDatasetMeta(t), s = {
      meta: i,
      index: t,
      mode: e,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", s) !== !1 && (i.controller._update(e), s.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", s));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (G.has(this) ? this.attached && !G.running(this) && G.start(this) : (this.draw(), ai({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: i, height: s } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(i, s);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this._layers;
    for (t = 0; t < e.length && e[t].z <= 0; ++t)
      e[t].draw(this.chartArea);
    for (this._drawDatasets(); t < e.length; ++t)
      e[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const e = this._sortedMetasets, i = [];
    let s, a;
    for (s = 0, a = e.length; s < a; ++s) {
      const o = e[s];
      (!t || o.visible) && i.push(o);
    }
    return i;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let e = t.length - 1; e >= 0; --e)
      this._drawDataset(t[e]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const e = this.ctx, i = {
      meta: t,
      index: t.index,
      cancelable: !0
    }, s = Si(this, t);
    this.notifyPlugins("beforeDatasetDraw", i) !== !1 && (s && Yt(e, s), t.controller.draw(), s && Xt(e), i.cancelable = !1, this.notifyPlugins("afterDatasetDraw", i));
  }
  isPointInArea(t) {
    return be(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, e, i, s) {
    const a = un.modes[e];
    return typeof a == "function" ? a(this, t, i, s) : [];
  }
  getDatasetMeta(t) {
    const e = this.data.datasets[t], i = this._metasets;
    let s = i.filter((a) => a && a._dataset === e).pop();
    return s || (s = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: e && e.order || 0,
      index: t,
      _dataset: e,
      _parsed: [],
      _sorted: !1
    }, i.push(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = ft(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const e = this.data.datasets[t];
    if (!e)
      return !1;
    const i = this.getDatasetMeta(t);
    return typeof i.hidden == "boolean" ? !i.hidden : !e.hidden;
  }
  setDatasetVisibility(t, e) {
    const i = this.getDatasetMeta(t);
    i.hidden = !e;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, e, i) {
    const s = i ? "show" : "hide", a = this.getDatasetMeta(t), o = a.controller._resolveAnimations(void 0, s);
    St(e) ? (a.data[e].hidden = !i, this.update()) : (this.setDatasetVisibility(t, i), o.update(a, {
      visible: i
    }), this.update((r) => r.datasetIndex === t ? s : void 0));
  }
  hide(t, e) {
    this._updateVisibility(t, e, !1);
  }
  show(t, e) {
    this._updateVisibility(t, e, !0);
  }
  _destroyDatasetMeta(t) {
    const e = this._metasets[t];
    e && e.controller && e.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, e;
    for (this.stop(), G.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: e } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), Se(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), delete $t[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, e = this.platform, i = (a, o) => {
      e.addEventListener(this, a, o), t[a] = o;
    }, s = (a, o, r) => {
      a.offsetX = o, a.offsetY = r, this._eventHandler(a);
    };
    C(this.options.events, (a) => i(a, s));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, e = this.platform, i = (h, l) => {
      e.addEventListener(this, h, l), t[h] = l;
    }, s = (h, l) => {
      t[h] && (e.removeEventListener(this, h, l), delete t[h]);
    }, a = (h, l) => {
      this.canvas && this.resize(h, l);
    };
    let o;
    const r = () => {
      s("attach", r), this.attached = !0, this.resize(), i("resize", a), i("detach", o);
    };
    o = () => {
      this.attached = !1, s("resize", a), this._stop(), this._resize(0, 0), i("attach", r);
    }, e.isAttached(this.canvas) ? r() : o();
  }
  unbindEvents() {
    C(this._listeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._listeners = {}, C(this._responsiveListeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, e, i) {
    const s = i ? "set" : "remove";
    let a, o, r, h;
    for (e === "dataset" && (a = this.getDatasetMeta(t[0].datasetIndex), a.controller["_" + s + "DatasetHoverStyle"]()), r = 0, h = t.length; r < h; ++r) {
      o = t[r];
      const l = o && this.getDatasetMeta(o.datasetIndex).controller;
      l && l[s + "HoverStyle"](o.element, o.datasetIndex, o.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const e = this._active || [], i = t.map(({ datasetIndex: s, index: a }) => {
      const o = this.getDatasetMeta(s);
      if (!o)
        throw new Error("No dataset found at index " + s);
      return {
        datasetIndex: s,
        element: o.data[a],
        index: a
      };
    });
    !Ht(i, e) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, e));
  }
  notifyPlugins(t, e, i) {
    return this._plugins.notify(this, t, e, i);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((e) => e.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, e, i) {
    const s = this.options.hover, a = (h, l) => h.filter((c) => !l.some((d) => c.datasetIndex === d.datasetIndex && c.index === d.index)), o = a(e, t), r = i ? t : a(t, e);
    o.length && this.updateHoverStyle(o, s.mode, !1), r.length && s.mode && this.updateHoverStyle(r, s.mode, !0);
  }
  _eventHandler(t, e) {
    const i = {
      event: t,
      replay: e,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, s = (o) => (o.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", i, s) === !1)
      return;
    const a = this._handleEvent(t, e, i.inChartArea);
    return i.cancelable = !1, this.notifyPlugins("afterEvent", i, s), (a || i.changed) && this.render(), this;
  }
  _handleEvent(t, e, i) {
    const { _active: s = [], options: a } = this, o = e, r = this._getActiveElements(t, s, i, o), h = ns(t), l = pa(t, this._lastEvent, i, h);
    i && (this._lastEvent = null, T(a.onHover, [
      t,
      r,
      this
    ], this), h && T(a.onClick, [
      t,
      r,
      this
    ], this));
    const c = !Ht(r, s);
    return (c || e) && (this._active = r, this._updateHoverStyles(r, s, e)), this._lastEvent = l, c;
  }
  _getActiveElements(t, e, i, s) {
    if (t.type === "mouseout")
      return [];
    if (!i)
      return e;
    const a = this.options.hover;
    return this.getElementsAtEventForMode(t, a.mode, a, s);
  }
}
function ri() {
  return C(xa.instances, (n) => n._plugins.invalidate());
}
function ji(n, t, e = t) {
  n.lineCap = P(e.borderCapStyle, t.borderCapStyle), n.setLineDash(P(e.borderDash, t.borderDash)), n.lineDashOffset = P(e.borderDashOffset, t.borderDashOffset), n.lineJoin = P(e.borderJoinStyle, t.borderJoinStyle), n.lineWidth = P(e.borderWidth, t.borderWidth), n.strokeStyle = P(e.borderColor, t.borderColor);
}
function ma(n, t, e) {
  n.lineTo(e.x, e.y);
}
function ba(n) {
  return n.stepped ? Cs : n.tension || n.cubicInterpolationMode === "monotone" ? Os : ma;
}
function Ui(n, t, e = {}) {
  const i = n.length, { start: s = 0, end: a = i - 1 } = e, { start: o, end: r } = t, h = Math.max(s, o), l = Math.min(a, r), c = s < o && a < o || s > r && a > r;
  return {
    count: i,
    start: h,
    loop: t.loop,
    ilen: l < h && !c ? i + l - h : l - h
  };
}
function _a(n, t, e, i) {
  const { points: s, options: a } = t, { count: o, start: r, loop: h, ilen: l } = Ui(s, e, i), c = ba(a);
  let { move: d = !0, reverse: u } = i || {}, g, f, p;
  for (g = 0; g <= l; ++g)
    f = s[(r + (u ? l - g : g)) % o], !f.skip && (d ? (n.moveTo(f.x, f.y), d = !1) : c(n, p, f, u, a.stepped), p = f);
  return h && (f = s[(r + (u ? l : 0)) % o], c(n, p, f, u, a.stepped)), !!h;
}
function ya(n, t, e, i) {
  const s = t.points, { count: a, start: o, ilen: r } = Ui(s, e, i), { move: h = !0, reverse: l } = i || {};
  let c = 0, d = 0, u, g, f, p, m, x;
  const v = (b) => (o + (l ? r - b : b)) % a, y = () => {
    p !== m && (n.lineTo(c, m), n.lineTo(c, p), n.lineTo(c, x));
  };
  for (h && (g = s[v(0)], n.moveTo(g.x, g.y)), u = 0; u <= r; ++u) {
    if (g = s[v(u)], g.skip)
      continue;
    const b = g.x, _ = g.y, M = b | 0;
    M === f ? (_ < p ? p = _ : _ > m && (m = _), c = (d * c + b) / ++d) : (y(), n.lineTo(b, _), f = M, d = 0, p = m = _), x = _;
  }
  y();
}
function xe(n) {
  const t = n.options, e = t.borderDash && t.borderDash.length;
  return !n._decimated && !n._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !e ? ya : _a;
}
function va(n) {
  return n.stepped ? ms : n.tension || n.cubicInterpolationMode === "monotone" ? bs : _s;
}
function wa(n, t, e, i) {
  let s = t._path;
  s || (s = t._path = new Path2D(), t.path(s, e, i) && s.closePath()), ji(n, t.options), n.stroke(s);
}
function Ma(n, t, e, i) {
  const { segments: s, options: a } = t, o = xe(t);
  for (const r of s)
    ji(n, a, r.style), n.beginPath(), o(n, t, r, {
      start: e,
      end: e + i - 1
    }) && n.closePath(), n.stroke();
}
const ka = typeof Path2D == "function";
function Sa(n, t, e, i) {
  ka && !t.options.segment ? wa(n, t, e, i) : Ma(n, t, e, i);
}
class ye extends it {
  static id = "line";
  static defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: !0,
    cubicInterpolationMode: "default",
    fill: !1,
    spanGaps: !1,
    stepped: !1,
    tension: 0
  };
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  static descriptors = {
    _scriptable: !0,
    _indexable: (t) => t !== "borderDash" && t !== "fill"
  };
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, e) {
    const i = this.options;
    if ((i.tension || i.cubicInterpolationMode === "monotone") && !i.stepped && !this._pointsUpdated) {
      const s = i.spanGaps ? this._loop : this._fullLoop;
      hs(this._points, i, t, s, e), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = ls(this, this.options.segment));
  }
  first() {
    const t = this.segments, e = this.points;
    return t.length && e[t[0].start];
  }
  last() {
    const t = this.segments, e = this.points, i = t.length;
    return i && e[t[i - 1].end];
  }
  interpolate(t, e) {
    const i = this.options, s = t[e], a = this.points, o = Di(this, {
      property: e,
      start: s,
      end: s
    });
    if (!o.length)
      return;
    const r = [], h = va(i);
    let l, c;
    for (l = 0, c = o.length; l < c; ++l) {
      const { start: d, end: u } = o[l], g = a[d], f = a[u];
      if (g === f) {
        r.push(g);
        continue;
      }
      const p = Math.abs((s - g[e]) / (f[e] - g[e])), m = h(g, f, p, i.stepped);
      m[e] = t[e], r.push(m);
    }
    return r.length === 1 ? r[0] : r;
  }
  pathSegment(t, e, i) {
    return xe(this)(t, this, e, i);
  }
  path(t, e, i) {
    const s = this.segments, a = xe(this);
    let o = this._loop;
    e = e || 0, i = i || this.points.length - e;
    for (const r of s)
      o &= a(t, this, r, {
        start: e,
        end: e + i - 1
      });
    return !!o;
  }
  draw(t, e, i, s) {
    const a = this.options || {};
    (this.points || []).length && a.borderWidth && (t.save(), Sa(t, this, i, s), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
function hi(n, t, e, i) {
  const s = n.options, { [e]: a } = n.getProps([
    e
  ], i);
  return Math.abs(t - a) < s.radius + s.hitRadius;
}
class _o extends it {
  static id = "point";
  parsed;
  skip;
  stop;
  /**
  * @type {any}
  */
  static defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
  };
  /**
  * @type {any}
  */
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  constructor(t) {
    super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
  }
  inRange(t, e, i) {
    const s = this.options, { x: a, y: o } = this.getProps([
      "x",
      "y"
    ], i);
    return Math.pow(t - a, 2) + Math.pow(e - o, 2) < Math.pow(s.hitRadius + s.radius, 2);
  }
  inXRange(t, e) {
    return hi(this, t, "x", e);
  }
  inYRange(t, e) {
    return hi(this, t, "y", e);
  }
  getCenterPoint(t) {
    const { x: e, y: i } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: i
    };
  }
  size(t) {
    t = t || this.options || {};
    let e = t.radius || 0;
    e = Math.max(e, e && t.hoverRadius || 0);
    const i = e && t.borderWidth || 0;
    return (e + i) * 2;
  }
  draw(t, e) {
    const i = this.options;
    this.skip || i.radius < 0.1 || !be(this, e, this.size(i) / 2) || (t.strokeStyle = i.borderColor, t.lineWidth = i.borderWidth, t.fillStyle = i.backgroundColor, ue(t, i, this.x, this.y));
  }
  getRange() {
    const t = this.options || {};
    return t.radius + t.hitRadius;
  }
}
function Yi(n, t) {
  const { x: e, y: i, base: s, width: a, height: o } = n.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let r, h, l, c, d;
  return n.horizontal ? (d = o / 2, r = Math.min(e, s), h = Math.max(e, s), l = i - d, c = i + d) : (d = a / 2, r = e - d, h = e + d, l = Math.min(i, s), c = Math.max(i, s)), {
    left: r,
    top: l,
    right: h,
    bottom: c
  };
}
function tt(n, t, e, i) {
  return n ? 0 : Z(t, e, i);
}
function Da(n, t, e) {
  const i = n.options.borderWidth, s = n.borderSkipped, a = Ds(i);
  return {
    t: tt(s.top, a.top, 0, e),
    r: tt(s.right, a.right, 0, t),
    b: tt(s.bottom, a.bottom, 0, e),
    l: tt(s.left, a.left, 0, t)
  };
}
function Pa(n, t, e) {
  const { enableBorderRadius: i } = n.getProps([
    "enableBorderRadius"
  ]), s = n.options.borderRadius, a = ct(s), o = Math.min(t, e), r = n.borderSkipped, h = i || E(s);
  return {
    topLeft: tt(!h || r.top || r.left, a.topLeft, 0, o),
    topRight: tt(!h || r.top || r.right, a.topRight, 0, o),
    bottomLeft: tt(!h || r.bottom || r.left, a.bottomLeft, 0, o),
    bottomRight: tt(!h || r.bottom || r.right, a.bottomRight, 0, o)
  };
}
function Aa(n) {
  const t = Yi(n), e = t.right - t.left, i = t.bottom - t.top, s = Da(n, e / 2, i / 2), a = Pa(n, e / 2, i / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: e,
      h: i,
      radius: a
    },
    inner: {
      x: t.left + s.l,
      y: t.top + s.t,
      w: e - s.l - s.r,
      h: i - s.t - s.b,
      radius: {
        topLeft: Math.max(0, a.topLeft - Math.max(s.t, s.l)),
        topRight: Math.max(0, a.topRight - Math.max(s.t, s.r)),
        bottomLeft: Math.max(0, a.bottomLeft - Math.max(s.b, s.l)),
        bottomRight: Math.max(0, a.bottomRight - Math.max(s.b, s.r))
      }
    }
  };
}
function re(n, t, e, i) {
  const s = t === null, a = e === null, o = n && !(s && a) && Yi(n, i);
  return o && (s || ot(t, o.left, o.right)) && (a || ot(e, o.top, o.bottom));
}
function Ca(n) {
  return n.topLeft || n.topRight || n.bottomLeft || n.bottomRight;
}
function Oa(n, t) {
  n.rect(t.x, t.y, t.w, t.h);
}
function he(n, t, e = {}) {
  const i = n.x !== e.x ? -t : 0, s = n.y !== e.y ? -t : 0, a = (n.x + n.w !== e.x + e.w ? t : 0) - i, o = (n.y + n.h !== e.y + e.h ? t : 0) - s;
  return {
    x: n.x + i,
    y: n.y + s,
    w: n.w + a,
    h: n.h + o,
    radius: n.radius
  };
}
class yo extends it {
  static id = "bar";
  static defaults = {
    borderSkipped: "start",
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: "auto",
    pointStyle: void 0
  };
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: e, options: { borderColor: i, backgroundColor: s } } = this, { inner: a, outer: o } = Aa(this), r = Ca(o.radius) ? Vt : Oa;
    t.save(), (o.w !== a.w || o.h !== a.h) && (t.beginPath(), r(t, he(o, e, a)), t.clip(), r(t, he(a, -e, o)), t.fillStyle = i, t.fill("evenodd")), t.beginPath(), r(t, he(a, e)), t.fillStyle = s, t.fill(), t.restore();
  }
  inRange(t, e, i) {
    return re(this, t, e, i);
  }
  inXRange(t, e) {
    return re(this, t, null, e);
  }
  inYRange(t, e) {
    return re(this, null, t, e);
  }
  getCenterPoint(t) {
    const { x: e, y: i, base: s, horizontal: a } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: a ? (e + s) / 2 : e,
      y: a ? i : (i + s) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
function Ta(n, t, e) {
  const i = n.segments, s = n.points, a = t.points, o = [];
  for (const r of i) {
    let { start: h, end: l } = r;
    l = Gt(h, l, s);
    const c = me(e, s[h], s[l], r.loop);
    if (!t.segments) {
      o.push({
        source: r,
        target: c,
        start: s[h],
        end: s[l]
      });
      continue;
    }
    const d = Di(t, c);
    for (const u of d) {
      const g = me(e, a[u.start], a[u.end], u.loop), f = Rs(r, s, g);
      for (const p of f)
        o.push({
          source: p,
          target: u,
          start: {
            [e]: li(c, g, "start", Math.max)
          },
          end: {
            [e]: li(c, g, "end", Math.min)
          }
        });
    }
  }
  return o;
}
function me(n, t, e, i) {
  if (i)
    return;
  let s = t[n], a = e[n];
  return n === "angle" && (s = Le(s), a = Le(a)), {
    property: n,
    start: s,
    end: a
  };
}
function Ia(n, t) {
  const { x: e = null, y: i = null } = n || {}, s = t.points, a = [];
  return t.segments.forEach(({ start: o, end: r }) => {
    r = Gt(o, r, s);
    const h = s[o], l = s[r];
    i !== null ? (a.push({
      x: h.x,
      y: i
    }), a.push({
      x: l.x,
      y: i
    })) : e !== null && (a.push({
      x: e,
      y: h.y
    }), a.push({
      x: e,
      y: l.y
    }));
  }), a;
}
function Gt(n, t, e) {
  for (; t > n; t--) {
    const i = e[t];
    if (!isNaN(i.x) && !isNaN(i.y))
      break;
  }
  return t;
}
function li(n, t, e, i) {
  return n && t ? i(n[e], t[e]) : n ? n[e] : t ? t[e] : 0;
}
function Xi(n, t) {
  let e = [], i = !1;
  return H(n) ? (i = !0, e = n) : e = Ia(n, t), e.length ? new ye({
    points: e,
    options: {
      tension: 0
    },
    _loop: i,
    _fullLoop: i
  }) : null;
}
function ci(n) {
  return n && n.fill !== !1;
}
function La(n, t, e) {
  let i = n[t].fill;
  const s = [
    t
  ];
  let a;
  if (!e)
    return i;
  for (; i !== !1 && s.indexOf(i) === -1; ) {
    if (!N(i))
      return i;
    if (a = n[i], !a)
      return !1;
    if (a.visible)
      return i;
    s.push(i), i = a.fill;
  }
  return !1;
}
function Ea(n, t, e) {
  const i = Fa(n);
  if (E(i))
    return isNaN(i.value) ? !1 : i;
  let s = parseFloat(i);
  return N(s) && Math.floor(s) === s ? Ra(i[0], t, s, e) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(i) >= 0 && i;
}
function Ra(n, t, e, i) {
  return (n === "-" || n === "+") && (e = t + e), e === t || e < 0 || e >= i ? !1 : e;
}
function za(n, t) {
  let e = null;
  return n === "start" ? e = t.bottom : n === "end" ? e = t.top : E(n) ? e = t.getPixelForValue(n.value) : t.getBasePixel && (e = t.getBasePixel()), e;
}
function Ba(n, t, e) {
  let i;
  return n === "start" ? i = e : n === "end" ? i = t.options.reverse ? t.min : t.max : E(n) ? i = n.value : i = t.getBaseValue(), i;
}
function Fa(n) {
  const t = n.options, e = t.fill;
  let i = P(e && e.target, e);
  return i === void 0 && (i = !!t.backgroundColor), i === !1 || i === null ? !1 : i === !0 ? "origin" : i;
}
function $a(n) {
  const { scale: t, index: e, line: i } = n, s = [], a = i.segments, o = i.points, r = Ha(t, e);
  r.push(Xi({
    x: null,
    y: t.bottom
  }, i));
  for (let h = 0; h < a.length; h++) {
    const l = a[h];
    for (let c = l.start; c <= l.end; c++)
      Va(s, o[c], r);
  }
  return new ye({
    points: s,
    options: {}
  });
}
function Ha(n, t) {
  const e = [], i = n.getMatchingVisibleMetas("line");
  for (let s = 0; s < i.length; s++) {
    const a = i[s];
    if (a.index === t)
      break;
    a.hidden || e.unshift(a.dataset);
  }
  return e;
}
function Va(n, t, e) {
  const i = [];
  for (let s = 0; s < e.length; s++) {
    const a = e[s], { first: o, last: r, point: h } = Wa(a, t, "x");
    if (!(!h || o && r)) {
      if (o)
        i.unshift(h);
      else if (n.push(h), !r)
        break;
    }
  }
  n.push(...i);
}
function Wa(n, t, e) {
  const i = n.interpolate(t, e);
  if (!i)
    return {};
  const s = i[e], a = n.segments, o = n.points;
  let r = !1, h = !1;
  for (let l = 0; l < a.length; l++) {
    const c = a[l], d = o[c.start][e], u = o[c.end][e];
    if (ot(s, d, u)) {
      r = s === d, h = s === u;
      break;
    }
  }
  return {
    first: r,
    last: h,
    point: i
  };
}
class Ki {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, e, i) {
    const { x: s, y: a, radius: o } = this;
    return e = e || {
      start: 0,
      end: lt
    }, t.arc(s, a, o, e.end, e.start, !0), !i.bounds;
  }
  interpolate(t) {
    const { x: e, y: i, radius: s } = this, a = t.angle;
    return {
      x: e + Math.cos(a) * s,
      y: i + Math.sin(a) * s,
      angle: a
    };
  }
}
function Na(n) {
  const { chart: t, fill: e, line: i } = n;
  if (N(e))
    return ja(t, e);
  if (e === "stack")
    return $a(n);
  if (e === "shape")
    return !0;
  const s = Ua(n);
  return s instanceof Ki ? s : Xi(s, i);
}
function ja(n, t) {
  const e = n.getDatasetMeta(t);
  return e && n.isDatasetVisible(t) ? e.dataset : null;
}
function Ua(n) {
  return (n.scale || {}).getPointPositionForValue ? Xa(n) : Ya(n);
}
function Ya(n) {
  const { scale: t = {}, fill: e } = n, i = za(e, t);
  if (N(i)) {
    const s = t.isHorizontal();
    return {
      x: s ? i : null,
      y: s ? null : i
    };
  }
  return null;
}
function Xa(n) {
  const { scale: t, fill: e } = n, i = t.options, s = t.getLabels().length, a = i.reverse ? t.max : t.min, o = Ba(e, t, a), r = [];
  if (i.grid.circular) {
    const h = t.getPointPositionForValue(0, a);
    return new Ki({
      x: h.x,
      y: h.y,
      radius: t.getDistanceFromCenterForValue(o)
    });
  }
  for (let h = 0; h < s; ++h)
    r.push(t.getPointPositionForValue(h, o));
  return r;
}
function le(n, t, e) {
  const i = Na(t), { chart: s, index: a, line: o, scale: r, axis: h } = t, l = o.options, c = l.fill, d = l.backgroundColor, { above: u = d, below: g = d } = c || {}, f = s.getDatasetMeta(a), p = Si(s, f);
  i && o.points.length && (Yt(n, e), Ka(n, {
    line: o,
    target: i,
    above: u,
    below: g,
    area: e,
    scale: r,
    axis: h,
    clip: p
  }), Xt(n));
}
function Ka(n, t) {
  const { line: e, target: i, above: s, below: a, area: o, scale: r, clip: h } = t, l = e._loop ? "angle" : t.axis;
  n.save();
  let c = a;
  a !== s && (l === "x" ? (di(n, i, o.top), ce(n, {
    line: e,
    target: i,
    color: s,
    scale: r,
    property: l,
    clip: h
  }), n.restore(), n.save(), di(n, i, o.bottom)) : l === "y" && (ui(n, i, o.left), ce(n, {
    line: e,
    target: i,
    color: a,
    scale: r,
    property: l,
    clip: h
  }), n.restore(), n.save(), ui(n, i, o.right), c = s)), ce(n, {
    line: e,
    target: i,
    color: c,
    scale: r,
    property: l,
    clip: h
  }), n.restore();
}
function di(n, t, e) {
  const { segments: i, points: s } = t;
  let a = !0, o = !1;
  n.beginPath();
  for (const r of i) {
    const { start: h, end: l } = r, c = s[h], d = s[Gt(h, l, s)];
    a ? (n.moveTo(c.x, c.y), a = !1) : (n.lineTo(c.x, e), n.lineTo(c.x, c.y)), o = !!t.pathSegment(n, r, {
      move: o
    }), o ? n.closePath() : n.lineTo(d.x, e);
  }
  n.lineTo(t.first().x, e), n.closePath(), n.clip();
}
function ui(n, t, e) {
  const { segments: i, points: s } = t;
  let a = !0, o = !1;
  n.beginPath();
  for (const r of i) {
    const { start: h, end: l } = r, c = s[h], d = s[Gt(h, l, s)];
    a ? (n.moveTo(c.x, c.y), a = !1) : (n.lineTo(e, c.y), n.lineTo(c.x, c.y)), o = !!t.pathSegment(n, r, {
      move: o
    }), o ? n.closePath() : n.lineTo(e, d.y);
  }
  n.lineTo(e, t.first().y), n.closePath(), n.clip();
}
function ce(n, t) {
  const { line: e, target: i, property: s, color: a, scale: o, clip: r } = t, h = Ta(e, i, s);
  for (const { source: l, target: c, start: d, end: u } of h) {
    const { style: { backgroundColor: g = a } = {} } = l, f = i !== !0;
    n.save(), n.fillStyle = g, qa(n, o, r, f && me(s, d, u)), n.beginPath();
    const p = !!e.pathSegment(n, l);
    let m;
    if (f) {
      p ? n.closePath() : gi(n, i, u, s);
      const x = !!i.pathSegment(n, c, {
        move: p,
        reverse: !0
      });
      m = p && x, m || gi(n, i, d, s);
    }
    n.closePath(), n.fill(m ? "evenodd" : "nonzero"), n.restore();
  }
}
function qa(n, t, e, i) {
  const s = t.chart.chartArea, { property: a, start: o, end: r } = i || {};
  if (a === "x" || a === "y") {
    let h, l, c, d;
    a === "x" ? (h = o, l = s.top, c = r, d = s.bottom) : (h = s.left, l = o, c = s.right, d = r), n.beginPath(), e && (h = Math.max(h, e.left), c = Math.min(c, e.right), l = Math.max(l, e.top), d = Math.min(d, e.bottom)), n.rect(h, l, c - h, d - l), n.clip();
  }
}
function gi(n, t, e, i) {
  const s = t.interpolate(e, i);
  s && n.lineTo(s.x, s.y);
}
var vo = {
  id: "filler",
  afterDatasetsUpdate(n, t, e) {
    const i = (n.data.datasets || []).length, s = [];
    let a, o, r, h;
    for (o = 0; o < i; ++o)
      a = n.getDatasetMeta(o), r = a.dataset, h = null, r && r.options && r instanceof ye && (h = {
        visible: n.isDatasetVisible(o),
        index: o,
        fill: Ea(r, o, i),
        chart: n,
        axis: a.controller.options.indexAxis,
        scale: a.vScale,
        line: r
      }), a.$filler = h, s.push(h);
    for (o = 0; o < i; ++o)
      h = s[o], !(!h || h.fill === !1) && (h.fill = La(s, o, e.propagate));
  },
  beforeDraw(n, t, e) {
    const i = e.drawTime === "beforeDraw", s = n.getSortedVisibleDatasetMetas(), a = n.chartArea;
    for (let o = s.length - 1; o >= 0; --o) {
      const r = s[o].$filler;
      r && (r.line.updateControlPoints(a, r.axis), i && r.fill && le(n.ctx, r, a));
    }
  },
  beforeDatasetsDraw(n, t, e) {
    if (e.drawTime !== "beforeDatasetsDraw")
      return;
    const i = n.getSortedVisibleDatasetMetas();
    for (let s = i.length - 1; s >= 0; --s) {
      const a = i[s].$filler;
      ci(a) && le(n.ctx, a, n.chartArea);
    }
  },
  beforeDatasetDraw(n, t, e) {
    const i = t.meta.$filler;
    !ci(i) || e.drawTime !== "beforeDatasetDraw" || le(n.ctx, i, n.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const fi = (n, t) => {
  let { boxHeight: e = t, boxWidth: i = t } = n;
  return n.usePointStyle && (e = Math.min(e, t), i = n.pointStyleWidth || Math.min(i, t)), {
    boxWidth: i,
    boxHeight: e,
    itemHeight: Math.max(t, e)
  };
}, Ga = (n, t) => n !== null && t !== null && n.datasetIndex === t.datasetIndex && n.index === t.index;
class pi extends it {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e, i) {
    this.maxWidth = t, this.maxHeight = e, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let e = T(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (e = e.filter((i) => t.filter(i, this.chart.data))), t.sort && (e = e.sort((i, s) => t.sort(i, s, this.chart.data))), this.options.reverse && e.reverse(), this.legendItems = e;
  }
  fit() {
    const { options: t, ctx: e } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const i = t.labels, s = F(i.font), a = s.size, o = this._computeTitleHeight(), { boxWidth: r, itemHeight: h } = fi(i, a);
    let l, c;
    e.font = s.string, this.isHorizontal() ? (l = this.maxWidth, c = this._fitRows(o, a, r, h) + 10) : (c = this.maxHeight, l = this._fitCols(o, s, r, h) + 10), this.width = Math.min(l, t.maxWidth || this.maxWidth), this.height = Math.min(c, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, e, i, s) {
    const { ctx: a, maxWidth: o, options: { labels: { padding: r } } } = this, h = this.legendHitBoxes = [], l = this.lineWidths = [
      0
    ], c = s + r;
    let d = t;
    a.textAlign = "left", a.textBaseline = "middle";
    let u = -1, g = -c;
    return this.legendItems.forEach((f, p) => {
      const m = i + e / 2 + a.measureText(f.text).width;
      (p === 0 || l[l.length - 1] + m + 2 * r > o) && (d += c, l[l.length - (p > 0 ? 0 : 1)] = 0, g += c, u++), h[p] = {
        left: 0,
        top: g,
        row: u,
        width: m,
        height: s
      }, l[l.length - 1] += m + r;
    }), d;
  }
  _fitCols(t, e, i, s) {
    const { ctx: a, maxHeight: o, options: { labels: { padding: r } } } = this, h = this.legendHitBoxes = [], l = this.columnSizes = [], c = o - t;
    let d = r, u = 0, g = 0, f = 0, p = 0;
    return this.legendItems.forEach((m, x) => {
      const { itemWidth: v, itemHeight: y } = Ja(i, e, a, m, s);
      x > 0 && g + y + 2 * r > c && (d += u + r, l.push({
        width: u,
        height: g
      }), f += u + r, p++, u = g = 0), h[x] = {
        left: f,
        top: g,
        col: p,
        width: v,
        height: y
      }, u = Math.max(u, v), g += y + r;
    }), d += u, l.push({
      width: u,
      height: g
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: e, options: { align: i, labels: { padding: s }, rtl: a } } = this, o = dt(a, this.left, this.width);
    if (this.isHorizontal()) {
      let r = 0, h = B(i, this.left + s, this.right - this.lineWidths[r]);
      for (const l of e)
        r !== l.row && (r = l.row, h = B(i, this.left + s, this.right - this.lineWidths[r])), l.top += this.top + t + s, l.left = o.leftForLtr(o.x(h), l.width), h += l.width + s;
    } else {
      let r = 0, h = B(i, this.top + t + s, this.bottom - this.columnSizes[r].height);
      for (const l of e)
        l.col !== r && (r = l.col, h = B(i, this.top + t + s, this.bottom - this.columnSizes[r].height)), l.top = h, l.left += this.left + s, l.left = o.leftForLtr(o.x(l.left), l.width), h += l.height + s;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      Yt(t, this), this._draw(), Xt(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: e, lineWidths: i, ctx: s } = this, { align: a, labels: o } = t, r = R.color, h = dt(t.rtl, this.left, this.width), l = F(o.font), { padding: c } = o, d = l.size, u = d / 2;
    let g;
    this.drawTitle(), s.textAlign = h.textAlign("left"), s.textBaseline = "middle", s.lineWidth = 0.5, s.font = l.string;
    const { boxWidth: f, boxHeight: p, itemHeight: m } = fi(o, d), x = function(M, k, w) {
      if (isNaN(f) || f <= 0 || isNaN(p) || p < 0)
        return;
      s.save();
      const I = P(w.lineWidth, 1);
      if (s.fillStyle = P(w.fillStyle, r), s.lineCap = P(w.lineCap, "butt"), s.lineDashOffset = P(w.lineDashOffset, 0), s.lineJoin = P(w.lineJoin, "miter"), s.lineWidth = I, s.strokeStyle = P(w.strokeStyle, r), s.setLineDash(P(w.lineDash, [])), o.usePointStyle) {
        const S = {
          radius: p * Math.SQRT2 / 2,
          pointStyle: w.pointStyle,
          rotation: w.rotation,
          borderWidth: I
        }, D = h.xPlus(M, f / 2), O = k + u;
        ys(s, S, D, O, o.pointStyleWidth && f);
      } else {
        const S = k + Math.max((d - p) / 2, 0), D = h.leftForLtr(M, f), O = ct(w.borderRadius);
        s.beginPath(), Object.values(O).some((j) => j !== 0) ? Vt(s, {
          x: D,
          y: S,
          w: f,
          h: p,
          radius: O
        }) : s.rect(D, S, f, p), s.fill(), I !== 0 && s.stroke();
      }
      s.restore();
    }, v = function(M, k, w) {
      Dt(s, w.text, M, k + m / 2, l, {
        strikethrough: w.hidden,
        textAlign: h.textAlign(w.textAlign)
      });
    }, y = this.isHorizontal(), b = this._computeTitleHeight();
    y ? g = {
      x: B(a, this.left + c, this.right - i[0]),
      y: this.top + c + b,
      line: 0
    } : g = {
      x: this.left + c,
      y: B(a, this.top + b + c, this.bottom - e[0].height),
      line: 0
    }, Pi(this.ctx, t.textDirection);
    const _ = m + c;
    this.legendItems.forEach((M, k) => {
      s.strokeStyle = M.fontColor, s.fillStyle = M.fontColor;
      const w = s.measureText(M.text).width, I = h.textAlign(M.textAlign || (M.textAlign = o.textAlign)), S = f + u + w;
      let D = g.x, O = g.y;
      h.setWidth(this.width), y ? k > 0 && D + S + c > this.right && (O = g.y += _, g.line++, D = g.x = B(a, this.left + c, this.right - i[g.line])) : k > 0 && O + _ > this.bottom && (D = g.x = D + e[g.line].width + c, g.line++, O = g.y = B(a, this.top + b + c, this.bottom - e[g.line].height));
      const j = h.x(D);
      if (x(j, O, M), D = ds(I, D + f + u, y ? D + S : this.right, t.rtl), v(h.x(D), O, M), y)
        g.x += S + c;
      else if (typeof M.text != "string") {
        const U = l.lineHeight;
        g.y += qi(M, U) + c;
      } else
        g.y += _;
    }), Ai(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, e = t.title, i = F(e.font), s = W(e.padding);
    if (!e.display)
      return;
    const a = dt(t.rtl, this.left, this.width), o = this.ctx, r = e.position, h = i.size / 2, l = s.top + h;
    let c, d = this.left, u = this.width;
    if (this.isHorizontal())
      u = Math.max(...this.lineWidths), c = this.top + l, d = B(t.align, d, this.right - u);
    else {
      const f = this.columnSizes.reduce((p, m) => Math.max(p, m.height), 0);
      c = l + B(t.align, this.top, this.bottom - f - t.labels.padding - this._computeTitleHeight());
    }
    const g = B(r, d, d + u);
    o.textAlign = a.textAlign(_e(r)), o.textBaseline = "middle", o.strokeStyle = e.color, o.fillStyle = e.color, o.font = i.string, Dt(o, e.text, g, c, i);
  }
  _computeTitleHeight() {
    const t = this.options.title, e = F(t.font), i = W(t.padding);
    return t.display ? e.lineHeight + i.height : 0;
  }
  _getLegendItemAt(t, e) {
    let i, s, a;
    if (ot(t, this.left, this.right) && ot(e, this.top, this.bottom)) {
      for (a = this.legendHitBoxes, i = 0; i < a.length; ++i)
        if (s = a[i], ot(t, s.left, s.left + s.width) && ot(e, s.top, s.top + s.height))
          return this.legendItems[i];
    }
    return null;
  }
  handleEvent(t) {
    const e = this.options;
    if (!to(t.type, e))
      return;
    const i = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const s = this._hoveredItem, a = Ga(s, i);
      s && !a && T(e.onLeave, [
        t,
        s,
        this
      ], this), this._hoveredItem = i, i && !a && T(e.onHover, [
        t,
        i,
        this
      ], this);
    } else i && T(e.onClick, [
      t,
      i,
      this
    ], this);
  }
}
function Ja(n, t, e, i, s) {
  const a = Qa(i, n, t, e), o = Za(s, i, t.lineHeight);
  return {
    itemWidth: a,
    itemHeight: o
  };
}
function Qa(n, t, e, i) {
  let s = n.text;
  return s && typeof s != "string" && (s = s.reduce((a, o) => a.length > o.length ? a : o)), t + e.size / 2 + i.measureText(s).width;
}
function Za(n, t, e) {
  let i = n;
  return typeof t.text != "string" && (i = qi(t, e)), i;
}
function qi(n, t) {
  const e = n.text ? n.text.length : 0;
  return t * e;
}
function to(n, t) {
  return !!((n === "mousemove" || n === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (n === "click" || n === "mouseup"));
}
var wo = {
  id: "legend",
  _element: pi,
  start(n, t, e) {
    const i = n.legend = new pi({
      ctx: n.ctx,
      options: e,
      chart: n
    });
    V.configure(n, i, e), V.addBox(n, i);
  },
  stop(n) {
    V.removeBox(n, n.legend), delete n.legend;
  },
  beforeUpdate(n, t, e) {
    const i = n.legend;
    V.configure(n, i, e), i.options = e;
  },
  afterUpdate(n) {
    const t = n.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(n, t) {
    t.replay || n.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(n, t, e) {
      const i = t.datasetIndex, s = e.chart;
      s.isDatasetVisible(i) ? (s.hide(i), t.hidden = !0) : (s.show(i), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (n) => n.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(n) {
        const t = n.data.datasets, { labels: { usePointStyle: e, pointStyle: i, textAlign: s, color: a, useBorderRadius: o, borderRadius: r } } = n.legend.options;
        return n._getSortedDatasetMetas().map((h) => {
          const l = h.controller.getStyle(e ? 0 : void 0), c = W(l.borderWidth);
          return {
            text: t[h.index].label,
            fillStyle: l.backgroundColor,
            fontColor: a,
            hidden: !h.visible,
            lineCap: l.borderCapStyle,
            lineDash: l.borderDash,
            lineDashOffset: l.borderDashOffset,
            lineJoin: l.borderJoinStyle,
            lineWidth: (c.width + c.height) / 4,
            strokeStyle: l.borderColor,
            pointStyle: i || l.pointStyle,
            rotation: l.rotation,
            textAlign: s || l.textAlign,
            borderRadius: o && (r || l.borderRadius),
            datasetIndex: h.index
          };
        }, this);
      }
    },
    title: {
      color: (n) => n.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (n) => !n.startsWith("on"),
    labels: {
      _scriptable: (n) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(n)
    }
  }
};
class Gi extends it {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e) {
    const i = this.options;
    if (this.left = 0, this.top = 0, !i.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = e;
    const s = H(i.text) ? i.text.length : 1;
    this._padding = W(i.padding);
    const a = s * F(i.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = a : this.width = a;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: e, left: i, bottom: s, right: a, options: o } = this, r = o.align;
    let h = 0, l, c, d;
    return this.isHorizontal() ? (c = B(r, i, a), d = e + t, l = a - i) : (o.position === "left" ? (c = i + t, d = B(r, s, e), h = Wt * -0.5) : (c = a - t, d = B(r, e, s), h = Wt * 0.5), l = s - e), {
      titleX: c,
      titleY: d,
      maxWidth: l,
      rotation: h
    };
  }
  draw() {
    const t = this.ctx, e = this.options;
    if (!e.display)
      return;
    const i = F(e.font), s = i.lineHeight / 2 + this._padding.top, { titleX: a, titleY: o, maxWidth: r, rotation: h } = this._drawArgs(s);
    Dt(t, e.text, 0, 0, i, {
      color: e.color,
      maxWidth: r,
      rotation: h,
      textAlign: _e(e.align),
      textBaseline: "middle",
      translation: [
        a,
        o
      ]
    });
  }
}
function eo(n, t) {
  const e = new Gi({
    ctx: n.ctx,
    options: t,
    chart: n
  });
  V.configure(n, e, t), V.addBox(n, e), n.titleBlock = e;
}
var Mo = {
  id: "title",
  _element: Gi,
  start(n, t, e) {
    eo(n, e);
  },
  stop(n) {
    const t = n.titleBlock;
    V.removeBox(n, t), delete n.titleBlock;
  },
  beforeUpdate(n, t, e) {
    const i = n.titleBlock;
    V.configure(n, i, e), i.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const kt = {
  average(n) {
    if (!n.length)
      return !1;
    let t, e, i = /* @__PURE__ */ new Set(), s = 0, a = 0;
    for (t = 0, e = n.length; t < e; ++t) {
      const o = n[t].element;
      if (o && o.hasValue()) {
        const r = o.tooltipPosition();
        i.add(r.x), s += r.y, ++a;
      }
    }
    return a === 0 || i.size === 0 ? !1 : {
      x: [
        ...i
      ].reduce((o, r) => o + r) / i.size,
      y: s / a
    };
  },
  nearest(n, t) {
    if (!n.length)
      return !1;
    let e = t.x, i = t.y, s = Number.POSITIVE_INFINITY, a, o, r;
    for (a = 0, o = n.length; a < o; ++a) {
      const h = n[a].element;
      if (h && h.hasValue()) {
        const l = h.getCenterPoint(), c = cs(t, l);
        c < s && (s = c, r = h);
      }
    }
    if (r) {
      const h = r.tooltipPosition();
      e = h.x, i = h.y;
    }
    return {
      x: e,
      y: i
    };
  }
};
function X(n, t) {
  return t && (H(t) ? Array.prototype.push.apply(n, t) : n.push(t)), n;
}
function J(n) {
  return (typeof n == "string" || n instanceof String) && n.indexOf(`
`) > -1 ? n.split(`
`) : n;
}
function io(n, t) {
  const { element: e, datasetIndex: i, index: s } = t, a = n.getDatasetMeta(i).controller, { label: o, value: r } = a.getLabelAndValue(s);
  return {
    chart: n,
    label: o,
    parsed: a.getParsed(s),
    raw: n.data.datasets[i].data[s],
    formattedValue: r,
    dataset: a.getDataset(),
    dataIndex: s,
    datasetIndex: i,
    element: e
  };
}
function xi(n, t) {
  const e = n.chart.ctx, { body: i, footer: s, title: a } = n, { boxWidth: o, boxHeight: r } = t, h = F(t.bodyFont), l = F(t.titleFont), c = F(t.footerFont), d = a.length, u = s.length, g = i.length, f = W(t.padding);
  let p = f.height, m = 0, x = i.reduce((b, _) => b + _.before.length + _.lines.length + _.after.length, 0);
  if (x += n.beforeBody.length + n.afterBody.length, d && (p += d * l.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), x) {
    const b = t.displayColors ? Math.max(r, h.lineHeight) : h.lineHeight;
    p += g * b + (x - g) * h.lineHeight + (x - 1) * t.bodySpacing;
  }
  u && (p += t.footerMarginTop + u * c.lineHeight + (u - 1) * t.footerSpacing);
  let v = 0;
  const y = function(b) {
    m = Math.max(m, e.measureText(b).width + v);
  };
  return e.save(), e.font = l.string, C(n.title, y), e.font = h.string, C(n.beforeBody.concat(n.afterBody), y), v = t.displayColors ? o + 2 + t.boxPadding : 0, C(i, (b) => {
    C(b.before, y), C(b.lines, y), C(b.after, y);
  }), v = 0, e.font = c.string, C(n.footer, y), e.restore(), m += f.width, {
    width: m,
    height: p
  };
}
function so(n, t) {
  const { y: e, height: i } = t;
  return e < i / 2 ? "top" : e > n.height - i / 2 ? "bottom" : "center";
}
function no(n, t, e, i) {
  const { x: s, width: a } = i, o = e.caretSize + e.caretPadding;
  if (n === "left" && s + a + o > t.width || n === "right" && s - a - o < 0)
    return !0;
}
function ao(n, t, e, i) {
  const { x: s, width: a } = e, { width: o, chartArea: { left: r, right: h } } = n;
  let l = "center";
  return i === "center" ? l = s <= (r + h) / 2 ? "left" : "right" : s <= a / 2 ? l = "left" : s >= o - a / 2 && (l = "right"), no(l, n, t, e) && (l = "center"), l;
}
function mi(n, t, e) {
  const i = e.yAlign || t.yAlign || so(n, e);
  return {
    xAlign: e.xAlign || t.xAlign || ao(n, t, e, i),
    yAlign: i
  };
}
function oo(n, t) {
  let { x: e, width: i } = n;
  return t === "right" ? e -= i : t === "center" && (e -= i / 2), e;
}
function ro(n, t, e) {
  let { y: i, height: s } = n;
  return t === "top" ? i += e : t === "bottom" ? i -= s + e : i -= s / 2, i;
}
function bi(n, t, e, i) {
  const { caretSize: s, caretPadding: a, cornerRadius: o } = n, { xAlign: r, yAlign: h } = e, l = s + a, { topLeft: c, topRight: d, bottomLeft: u, bottomRight: g } = ct(o);
  let f = oo(t, r);
  const p = ro(t, h, l);
  return h === "center" ? r === "left" ? f += l : r === "right" && (f -= l) : r === "left" ? f -= Math.max(c, u) + s : r === "right" && (f += Math.max(d, g) + s), {
    x: Z(f, 0, i.width - t.width),
    y: Z(p, 0, i.height - t.height)
  };
}
function Bt(n, t, e) {
  const i = W(e.padding);
  return t === "center" ? n.x + n.width / 2 : t === "right" ? n.x + n.width - i.right : n.x + i.left;
}
function _i(n) {
  return X([], J(n));
}
function ho(n, t, e) {
  return ft(n, {
    tooltip: t,
    tooltipItems: e,
    type: "tooltip"
  });
}
function yi(n, t) {
  const e = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return e ? n.override(e) : n;
}
const Ji = {
  beforeTitle: q,
  title(n) {
    if (n.length > 0) {
      const t = n[0], e = t.chart.data.labels, i = e ? e.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (i > 0 && t.dataIndex < i)
        return e[t.dataIndex];
    }
    return "";
  },
  afterTitle: q,
  beforeBody: q,
  beforeLabel: q,
  label(n) {
    if (this && this.options && this.options.mode === "dataset")
      return n.label + ": " + n.formattedValue || n.formattedValue;
    let t = n.dataset.label || "";
    t && (t += ": ");
    const e = n.formattedValue;
    return L(e) || (t += e), t;
  },
  labelColor(n) {
    const t = n.chart.getDatasetMeta(n.datasetIndex).controller.getStyle(n.dataIndex);
    return {
      borderColor: t.borderColor,
      backgroundColor: t.backgroundColor,
      borderWidth: t.borderWidth,
      borderDash: t.borderDash,
      borderDashOffset: t.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(n) {
    const t = n.chart.getDatasetMeta(n.datasetIndex).controller.getStyle(n.dataIndex);
    return {
      pointStyle: t.pointStyle,
      rotation: t.rotation
    };
  },
  afterLabel: q,
  afterBody: q,
  beforeFooter: q,
  footer: q,
  afterFooter: q
};
function $(n, t, e, i) {
  const s = n[t].call(e, i);
  return typeof s > "u" ? Ji[t].call(e, i) : s;
}
class vi extends it {
  static positioners = kt;
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const e = this.chart, i = this.options.setContext(this.getContext()), s = i.enabled && e.options.animation && i.animations, a = new Ii(this.chart, s);
    return s._cacheable && (this._cachedAnimations = Object.freeze(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = ho(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, e) {
    const { callbacks: i } = e, s = $(i, "beforeTitle", this, t), a = $(i, "title", this, t), o = $(i, "afterTitle", this, t);
    let r = [];
    return r = X(r, J(s)), r = X(r, J(a)), r = X(r, J(o)), r;
  }
  getBeforeBody(t, e) {
    return _i($(e.callbacks, "beforeBody", this, t));
  }
  getBody(t, e) {
    const { callbacks: i } = e, s = [];
    return C(t, (a) => {
      const o = {
        before: [],
        lines: [],
        after: []
      }, r = yi(i, a);
      X(o.before, J($(r, "beforeLabel", this, a))), X(o.lines, $(r, "label", this, a)), X(o.after, J($(r, "afterLabel", this, a))), s.push(o);
    }), s;
  }
  getAfterBody(t, e) {
    return _i($(e.callbacks, "afterBody", this, t));
  }
  getFooter(t, e) {
    const { callbacks: i } = e, s = $(i, "beforeFooter", this, t), a = $(i, "footer", this, t), o = $(i, "afterFooter", this, t);
    let r = [];
    return r = X(r, J(s)), r = X(r, J(a)), r = X(r, J(o)), r;
  }
  _createItems(t) {
    const e = this._active, i = this.chart.data, s = [], a = [], o = [];
    let r = [], h, l;
    for (h = 0, l = e.length; h < l; ++h)
      r.push(io(this.chart, e[h]));
    return t.filter && (r = r.filter((c, d, u) => t.filter(c, d, u, i))), t.itemSort && (r = r.sort((c, d) => t.itemSort(c, d, i))), C(r, (c) => {
      const d = yi(t.callbacks, c);
      s.push($(d, "labelColor", this, c)), a.push($(d, "labelPointStyle", this, c)), o.push($(d, "labelTextColor", this, c));
    }), this.labelColors = s, this.labelPointStyles = a, this.labelTextColors = o, this.dataPoints = r, r;
  }
  update(t, e) {
    const i = this.options.setContext(this.getContext()), s = this._active;
    let a, o = [];
    if (!s.length)
      this.opacity !== 0 && (a = {
        opacity: 0
      });
    else {
      const r = kt[i.position].call(this, s, this._eventPosition);
      o = this._createItems(i), this.title = this.getTitle(o, i), this.beforeBody = this.getBeforeBody(o, i), this.body = this.getBody(o, i), this.afterBody = this.getAfterBody(o, i), this.footer = this.getFooter(o, i);
      const h = this._size = xi(this, i), l = Object.assign({}, r, h), c = mi(this.chart, i, l), d = bi(i, l, c, this.chart);
      this.xAlign = c.xAlign, this.yAlign = c.yAlign, a = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: h.width,
        height: h.height,
        caretX: r.x,
        caretY: r.y
      };
    }
    this._tooltipItems = o, this.$context = void 0, a && this._resolveAnimations().update(this, a), t && i.external && i.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: e
    });
  }
  drawCaret(t, e, i, s) {
    const a = this.getCaretPosition(t, i, s);
    e.lineTo(a.x1, a.y1), e.lineTo(a.x2, a.y2), e.lineTo(a.x3, a.y3);
  }
  getCaretPosition(t, e, i) {
    const { xAlign: s, yAlign: a } = this, { caretSize: o, cornerRadius: r } = i, { topLeft: h, topRight: l, bottomLeft: c, bottomRight: d } = ct(r), { x: u, y: g } = t, { width: f, height: p } = e;
    let m, x, v, y, b, _;
    return a === "center" ? (b = g + p / 2, s === "left" ? (m = u, x = m - o, y = b + o, _ = b - o) : (m = u + f, x = m + o, y = b - o, _ = b + o), v = m) : (s === "left" ? x = u + Math.max(h, c) + o : s === "right" ? x = u + f - Math.max(l, d) - o : x = this.caretX, a === "top" ? (y = g, b = y - o, m = x - o, v = x + o) : (y = g + p, b = y + o, m = x + o, v = x - o), _ = y), {
      x1: m,
      x2: x,
      x3: v,
      y1: y,
      y2: b,
      y3: _
    };
  }
  drawTitle(t, e, i) {
    const s = this.title, a = s.length;
    let o, r, h;
    if (a) {
      const l = dt(i.rtl, this.x, this.width);
      for (t.x = Bt(this, i.titleAlign, i), e.textAlign = l.textAlign(i.titleAlign), e.textBaseline = "middle", o = F(i.titleFont), r = i.titleSpacing, e.fillStyle = i.titleColor, e.font = o.string, h = 0; h < a; ++h)
        e.fillText(s[h], l.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + r, h + 1 === a && (t.y += i.titleMarginBottom - r);
    }
  }
  _drawColorBox(t, e, i, s, a) {
    const o = this.labelColors[i], r = this.labelPointStyles[i], { boxHeight: h, boxWidth: l } = a, c = F(a.bodyFont), d = Bt(this, "left", a), u = s.x(d), g = h < c.lineHeight ? (c.lineHeight - h) / 2 : 0, f = e.y + g;
    if (a.usePointStyle) {
      const p = {
        radius: Math.min(l, h) / 2,
        pointStyle: r.pointStyle,
        rotation: r.rotation,
        borderWidth: 1
      }, m = s.leftForLtr(u, l) + l / 2, x = f + h / 2;
      t.strokeStyle = a.multiKeyBackground, t.fillStyle = a.multiKeyBackground, ue(t, p, m, x), t.strokeStyle = o.borderColor, t.fillStyle = o.backgroundColor, ue(t, p, m, x);
    } else {
      t.lineWidth = E(o.borderWidth) ? Math.max(...Object.values(o.borderWidth)) : o.borderWidth || 1, t.strokeStyle = o.borderColor, t.setLineDash(o.borderDash || []), t.lineDashOffset = o.borderDashOffset || 0;
      const p = s.leftForLtr(u, l), m = s.leftForLtr(s.xPlus(u, 1), l - 2), x = ct(o.borderRadius);
      Object.values(x).some((v) => v !== 0) ? (t.beginPath(), t.fillStyle = a.multiKeyBackground, Vt(t, {
        x: p,
        y: f,
        w: l,
        h,
        radius: x
      }), t.fill(), t.stroke(), t.fillStyle = o.backgroundColor, t.beginPath(), Vt(t, {
        x: m,
        y: f + 1,
        w: l - 2,
        h: h - 2,
        radius: x
      }), t.fill()) : (t.fillStyle = a.multiKeyBackground, t.fillRect(p, f, l, h), t.strokeRect(p, f, l, h), t.fillStyle = o.backgroundColor, t.fillRect(m, f + 1, l - 2, h - 2));
    }
    t.fillStyle = this.labelTextColors[i];
  }
  drawBody(t, e, i) {
    const { body: s } = this, { bodySpacing: a, bodyAlign: o, displayColors: r, boxHeight: h, boxWidth: l, boxPadding: c } = i, d = F(i.bodyFont);
    let u = d.lineHeight, g = 0;
    const f = dt(i.rtl, this.x, this.width), p = function(w) {
      e.fillText(w, f.x(t.x + g), t.y + u / 2), t.y += u + a;
    }, m = f.textAlign(o);
    let x, v, y, b, _, M, k;
    for (e.textAlign = o, e.textBaseline = "middle", e.font = d.string, t.x = Bt(this, m, i), e.fillStyle = i.bodyColor, C(this.beforeBody, p), g = r && m !== "right" ? o === "center" ? l / 2 + c : l + 2 + c : 0, b = 0, M = s.length; b < M; ++b) {
      for (x = s[b], v = this.labelTextColors[b], e.fillStyle = v, C(x.before, p), y = x.lines, r && y.length && (this._drawColorBox(e, t, b, f, i), u = Math.max(d.lineHeight, h)), _ = 0, k = y.length; _ < k; ++_)
        p(y[_]), u = d.lineHeight;
      C(x.after, p);
    }
    g = 0, u = d.lineHeight, C(this.afterBody, p), t.y -= a;
  }
  drawFooter(t, e, i) {
    const s = this.footer, a = s.length;
    let o, r;
    if (a) {
      const h = dt(i.rtl, this.x, this.width);
      for (t.x = Bt(this, i.footerAlign, i), t.y += i.footerMarginTop, e.textAlign = h.textAlign(i.footerAlign), e.textBaseline = "middle", o = F(i.footerFont), e.fillStyle = i.footerColor, e.font = o.string, r = 0; r < a; ++r)
        e.fillText(s[r], h.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + i.footerSpacing;
    }
  }
  drawBackground(t, e, i, s) {
    const { xAlign: a, yAlign: o } = this, { x: r, y: h } = t, { width: l, height: c } = i, { topLeft: d, topRight: u, bottomLeft: g, bottomRight: f } = ct(s.cornerRadius);
    e.fillStyle = s.backgroundColor, e.strokeStyle = s.borderColor, e.lineWidth = s.borderWidth, e.beginPath(), e.moveTo(r + d, h), o === "top" && this.drawCaret(t, e, i, s), e.lineTo(r + l - u, h), e.quadraticCurveTo(r + l, h, r + l, h + u), o === "center" && a === "right" && this.drawCaret(t, e, i, s), e.lineTo(r + l, h + c - f), e.quadraticCurveTo(r + l, h + c, r + l - f, h + c), o === "bottom" && this.drawCaret(t, e, i, s), e.lineTo(r + g, h + c), e.quadraticCurveTo(r, h + c, r, h + c - g), o === "center" && a === "left" && this.drawCaret(t, e, i, s), e.lineTo(r, h + d), e.quadraticCurveTo(r, h, r + d, h), e.closePath(), e.fill(), s.borderWidth > 0 && e.stroke();
  }
  _updateAnimationTarget(t) {
    const e = this.chart, i = this.$animations, s = i && i.x, a = i && i.y;
    if (s || a) {
      const o = kt[t.position].call(this, this._active, this._eventPosition);
      if (!o)
        return;
      const r = this._size = xi(this, t), h = Object.assign({}, o, this._size), l = mi(e, t, h), c = bi(t, h, l, e);
      (s._to !== c.x || a._to !== c.y) && (this.xAlign = l.xAlign, this.yAlign = l.yAlign, this.width = r.width, this.height = r.height, this.caretX = o.x, this.caretY = o.y, this._resolveAnimations().update(this, c));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const e = this.options.setContext(this.getContext());
    let i = this.opacity;
    if (!i)
      return;
    this._updateAnimationTarget(e);
    const s = {
      width: this.width,
      height: this.height
    }, a = {
      x: this.x,
      y: this.y
    };
    i = Math.abs(i) < 1e-3 ? 0 : i;
    const o = W(e.padding), r = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    e.enabled && r && (t.save(), t.globalAlpha = i, this.drawBackground(a, t, s, e), Pi(t, e.textDirection), a.y += o.top, this.drawTitle(a, t, e), this.drawBody(a, t, e), this.drawFooter(a, t, e), Ai(t, e.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, e) {
    const i = this._active, s = t.map(({ datasetIndex: r, index: h }) => {
      const l = this.chart.getDatasetMeta(r);
      if (!l)
        throw new Error("Cannot find a dataset at index " + r);
      return {
        datasetIndex: r,
        element: l.data[h],
        index: h
      };
    }), a = !Ht(i, s), o = this._positionChanged(s, e);
    (a || o) && (this._active = s, this._eventPosition = e, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, e, i = !0) {
    if (e && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const s = this.options, a = this._active || [], o = this._getActiveElements(t, a, e, i), r = this._positionChanged(o, t), h = e || !Ht(o, a) || r;
    return h && (this._active = o, (s.enabled || s.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, e))), h;
  }
  _getActiveElements(t, e, i, s) {
    const a = this.options;
    if (t.type === "mouseout")
      return [];
    if (!s)
      return e.filter((r) => this.chart.data.datasets[r.datasetIndex] && this.chart.getDatasetMeta(r.datasetIndex).controller.getParsed(r.index) !== void 0);
    const o = this.chart.getElementsAtEventForMode(t, a.mode, a, i);
    return a.reverse && o.reverse(), o;
  }
  _positionChanged(t, e) {
    const { caretX: i, caretY: s, options: a } = this, o = kt[a.position].call(this, t, e);
    return o !== !1 && (i !== o.x || s !== o.y);
  }
}
var ko = {
  id: "tooltip",
  _element: vi,
  positioners: kt,
  afterInit(n, t, e) {
    e && (n.tooltip = new vi({
      chart: n,
      options: e
    }));
  },
  beforeUpdate(n, t, e) {
    n.tooltip && n.tooltip.initialize(e);
  },
  reset(n, t, e) {
    n.tooltip && n.tooltip.initialize(e);
  },
  afterDraw(n) {
    const t = n.tooltip;
    if (t && t._willRender()) {
      const e = {
        tooltip: t
      };
      if (n.notifyPlugins("beforeTooltipDraw", {
        ...e,
        cancelable: !0
      }) === !1)
        return;
      t.draw(n.ctx), n.notifyPlugins("afterTooltipDraw", e);
    }
  },
  afterEvent(n, t) {
    if (n.tooltip) {
      const e = t.replay;
      n.tooltip.handleEvent(t.event, e, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (n, t) => t.bodyFont.size,
    boxWidth: (n, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Ji
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (n) => n !== "filter" && n !== "itemSort" && n !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const lo = (n, t, e, i) => (typeof t == "string" ? (e = n.push(t) - 1, i.unshift({
  index: e,
  label: t
})) : isNaN(t) && (e = null), e);
function co(n, t, e, i) {
  const s = n.indexOf(t);
  if (s === -1)
    return lo(n, t, e, i);
  const a = n.lastIndexOf(t);
  return s !== a ? e : s;
}
const uo = (n, t) => n === null ? null : Z(Math.round(n), 0, t);
function wi(n) {
  const t = this.getLabels();
  return n >= 0 && n < t.length ? t[n] : n;
}
class So extends At {
  static id = "category";
  static defaults = {
    ticks: {
      callback: wi
    }
  };
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const e = this._addedLabels;
    if (e.length) {
      const i = this.getLabels();
      for (const { index: s, label: a } of e)
        i[s] === a && i.splice(s, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, e) {
    if (L(t))
      return null;
    const i = this.getLabels();
    return e = isFinite(e) && i[e] === t ? e : co(i, t, P(e, t), this._addedLabels), uo(e, i.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let { min: i, max: s } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (i = 0), e || (s = this.getLabels().length - 1)), this.min = i, this.max = s;
  }
  buildTicks() {
    const t = this.min, e = this.max, i = this.options.offset, s = [];
    let a = this.getLabels();
    a = t === 0 && e === a.length - 1 ? a : a.slice(t, e + 1), this._valueRange = Math.max(a.length - (i ? 0 : 1), 1), this._startValue = this.min - (i ? 0.5 : 0);
    for (let o = t; o <= e; o++)
      s.push({
        value: o
      });
    return s;
  }
  getLabelForValue(t) {
    return wi.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
function go(n, t) {
  const e = [], { bounds: i, step: s, min: a, max: o, precision: r, count: h, maxTicks: l, maxDigits: c, includeBounds: d } = n, u = s || 1, g = l - 1, { min: f, max: p } = t, m = !L(a), x = !L(o), v = !L(h), y = (p - f) / (c + 1);
  let b = Oe((p - f) / g / u) * u, _, M, k, w;
  if (b < 1e-14 && !m && !x)
    return [
      {
        value: f
      },
      {
        value: p
      }
    ];
  w = Math.ceil(p / b) - Math.floor(f / b), w > g && (b = Oe(w * b / g / u) * u), L(r) || (_ = Math.pow(10, r), b = Math.ceil(b * _) / _), i === "ticks" ? (M = Math.floor(f / b) * b, k = Math.ceil(p / b) * b) : (M = f, k = p), m && x && s && Ss((o - a) / s, b / 1e3) ? (w = Math.round(Math.min((o - a) / b, l)), b = (o - a) / w, M = a, k = o) : v ? (M = m ? a : M, k = x ? o : k, w = h - 1, b = (k - M) / w) : (w = (k - M) / b, Qt(w, Math.round(w), b / 1e3) ? w = Math.round(w) : w = Math.ceil(w));
  const I = Math.max(Ie(b), Ie(M));
  _ = Math.pow(10, L(r) ? I : r), M = Math.round(M * _) / _, k = Math.round(k * _) / _;
  let S = 0;
  for (m && (d && M !== a ? (e.push({
    value: a
  }), M < a && S++, Qt(Math.round((M + S * b) * _) / _, a, Mi(a, y, n)) && S++) : M < a && S++); S < w; ++S) {
    const D = Math.round((M + S * b) * _) / _;
    if (x && D > o)
      break;
    e.push({
      value: D
    });
  }
  return x && d && k !== o ? e.length && Qt(e[e.length - 1].value, o, Mi(o, y, n)) ? e[e.length - 1].value = o : e.push({
    value: o
  }) : (!x || k === o) && e.push({
    value: k
  }), e;
}
function Mi(n, t, { horizontal: e, minRotation: i }) {
  const s = Q(i), a = (e ? Math.sin(s) : Math.cos(s)) || 1e-3, o = 0.75 * t * ("" + n).length;
  return Math.min(t / a, o);
}
class fo extends At {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    return L(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: e, maxDefined: i } = this.getUserBounds();
    let { min: s, max: a } = this;
    const o = (h) => s = e ? s : h, r = (h) => a = i ? a : h;
    if (t) {
      const h = et(s), l = et(a);
      h < 0 && l < 0 ? r(0) : h > 0 && l > 0 && o(0);
    }
    if (s === a) {
      let h = a === 0 ? 1 : Math.abs(a * 0.05);
      r(a + h), t || o(s - h);
    }
    this.min = s, this.max = a;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: e, stepSize: i } = t, s;
    return i ? (s = Math.ceil(this.max / i) - Math.floor(this.min / i) + 1, s > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${i} would result generating up to ${s} ticks. Limiting to 1000.`), s = 1e3)) : (s = this.computeTickLimit(), e = e || 11), e && (s = Math.min(e, s)), s;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, e = t.ticks;
    let i = this.getTickLimit();
    i = Math.max(2, i);
    const s = {
      maxTicks: i,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: e.precision,
      step: e.stepSize,
      count: e.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: e.minRotation || 0,
      includeBounds: e.includeBounds !== !1
    }, a = this._range || this, o = go(s, a);
    return t.bounds === "ticks" && xs(o, this, "value"), t.reverse ? (o.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), o;
  }
  configure() {
    const t = this.ticks;
    let e = this.min, i = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const s = (i - e) / Math.max(t.length - 1, 1) / 2;
      e -= s, i += s;
    }
    this._startValue = e, this._endValue = i, this._valueRange = i - e;
  }
  getLabelForValue(t) {
    return ki(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Do extends fo {
  static id = "linear";
  static defaults = {
    ticks: {
      callback: rs.formatters.numeric
    }
  };
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = N(t) ? t : 0, this.max = N(e) ? e : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), e = t ? this.width : this.height, i = Q(this.options.ticks.minRotation), s = (t ? Math.sin(i) : Math.cos(i)) || 1e-3, a = this._resolveTickFontOptions(0);
    return Math.ceil(e / Math.min(40, a.lineHeight / s));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
export {
  Fs as Animation,
  Ii as Animations,
  xo as BarController,
  yo as BarElement,
  Bi as BasePlatform,
  yn as BasicPlatform,
  So as CategoryScale,
  xa as Chart,
  Kt as DatasetController,
  In as DomPlatform,
  mo as DoughnutController,
  it as Element,
  vo as Filler,
  un as Interaction,
  wo as Legend,
  bo as LineController,
  ye as LineElement,
  Do as LinearScale,
  _o as PointElement,
  At as Scale,
  rs as Ticks,
  Mo as Title,
  ko as Tooltip,
  Ln as _detectPlatform,
  G as animator,
  R as defaults,
  V as layouts,
  K as registry
};
//# sourceMappingURL=index.es161.js.map
